/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "uXl7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "CvhG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBst":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "EvNc":
/***/ (function(module, exports) {

module.exports.RESOURCES = [{ key: 'food', char: '\uE904' }, { key: 'fuel', char: '\uE905' }, { key: 'water', char: '\uE90A' }];

module.exports.UNREST = [{ key: 'conflict', char: '\uE902' }, { key: 'demo', char: '\uE903', label: 'Demonstrations', labelShort: 'Demos' }, { key: 'looting', char: '\uE906' }, { key: 'protest', char: '\uE907' }, { key: 'riot', char: '\uE908' }, { key: 'suicide', char: '\uE909' }];

/***/ }),

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fil1":
/***/ (function(module, exports) {

module.exports = {"zaf":{"name":"South Africa","total":{"num injured":16,"num dead":14,"num participants":1502,"num arrests":9},"totalByYear":{"2013":{"num dead":1},"2014":{"num injured":16,"num dead":11,"num participants":1500,"num arrests":9},"2017":{"num dead":2,"num participants":2}},"eventsByYear":{"2013":[{"startDate":"2013-04-13","is water":true,"is protest":true,"num dead":1}],"2014":[{"startDate":"2014-01-14","is water":true,"is protest":true,"num injured":1,"num dead":4},{"startDate":"2014-01-01","is water":true,"is protest":true,"num participants":1500,"num arrests":9,"num injured":15,"num dead":3},{"startDate":"2014","is water":true,"is protest":true,"num dead":3},{"startDate":"2014-01-19","is water":true,"is protest":true,"num dead":1}],"2017":[{"startDate":"2017/01/01","is water":true,"is protest":true,"num dead":1},{"startDate":"2017-03-01","is water":true,"is conflict":true,"num participants":2,"num dead":1}]}},"lka":{"name":"Sri Lanka","total":{"num participants":4000,"num injured":15,"num dead":426},"totalByYear":{"2006":{"num dead":425},"2013":{"num participants":4000,"num injured":15,"num dead":1}},"eventsByYear":{"2006":[{"startDate":"2006-08-01","is water":true,"is conflict":true,"num dead":425}],"2013":[{"startDate":"2013-01-08","is water":true,"is protest":true,"num participants":4000,"num injured":15,"num dead":1}]}},"ind":{"name":"India","total":{"num participants":1308,"num dead":118,"num arrests":201,"num injured":338,"num suicide":311},"totalByYear":{"2005":{"num participants":200,"num injured":24,"num dead":10},"2006":{"num dead":20,"num injured":6},"2007":{"num dead":27,"num injured":300,"num suicide":3},"2008":{"num participants":100,"num dead":2},"2009":{"num participants":1008,"num dead":10,"num injured":4,"num suicide":3},"2010":{"num dead":4,"num suicide":19},"2011":{"num dead":3,"num suicide":6},"2012":{"num dead":2,"num injured":4,"num suicide":10},"2013":{"num dead":1,"num suicide":2},"2014":{"num dead":1,"num suicide":1},"2015":{"num dead":1,"num suicide":67},"2016":{"num arrests":200,"num dead":34,"num suicide":177},"2017":{"num dead":3,"num arrests":1,"num suicide":23}},"eventsByYear":{"2005":[{"startDate":"2005-06-13","is water":true,"is protest":true,"is riot":true,"num participants":200,"num injured":24,"num dead":5},{"startDate":"2005-06-01","is water":true,"is protest":true,"num dead":5}],"2006":[{"startDate":"2006-03-01","is water":true,"is protest":true,"num dead":1},{"startDate":"2006-03-01","is water":true,"is demo":true,"num dead":8},{"startDate":"2006-03-01","is water":true,"is conflict":true,"num dead":6},{"startDate":"2006-03-01","is water":true,"is protest":true,"num dead":2},{"startDate":"2006-03-01","is water":true,"is protest":true,"num dead":2},{"startDate":"2006-06-01","is water":true,"is conflict":true,"num injured":6,"num dead":1}],"2007":[{"startDate":"2007-06-01","is water":true,"is protest":true,"is conflict":true,"num dead":25},{"startDate":"2007-10-01","is food":true,"is looting":true,"is protest":true,"is riot":true,"num injured":300,"num suicide":3,"num dead":2,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/west-bengal","title":"West Bengal: Food Insecurity Suspicions Confirmed, Riots Follow.","summary":"The State of West Bengal has for many years operated the national Public Distribution System (PDS) to supply essential commodities at a subsidised price through an extensive network of fair-priced shops to both rural and urban Below Poverty Level (BPL) households. However, concerns about food security in the region were apparent for years. In fact, food had become highly politicised, with those who distributed it becoming wealthy and powerful, at the expense of those most in need.","city":"Burdwan"}}],"2008":[{"startDate":"2008-04-01","is water":true,"is looting":true,"is conflict":true,"num participants":100,"num dead":1},{"startDate":"2008-08-01","is food":true,"is riot":true,"num dead":1}],"2009":[{"startDate":"2009-12-03","is water":true,"is protest":true,"num participants":1000,"num dead":1},{"startDate":"2009-05-13","is water":true,"is looting":true,"is conflict":true,"num dead":3},{"startDate":"2009-02-01","is water":true,"is protest":true,"is conflict":true,"num dead":1},{"startDate":"2009-03-01","is water":true,"is protest":true,"is conflict":true,"num injured":4,"num dead":1},{"startDate":"2009-03-01","is water":true,"is protest":true,"is conflict":true,"num dead":1},{"startDate":"2009-06-23","is water":true,"is conflict":true,"num dead":1},{"startDate":"2009-08-01","is water":true,"is conflict":true,"num participants":3,"num dead":1},{"startDate":"2009-05-01","is water":true,"num suicide":1},{"startDate":"2009-05-01","is water":true,"is conflict":true,"num participants":5,"num dead":1},{"startDate":"2009-11-01","is food":true,"num suicide":2}],"2010":[{"startDate":"2010-05-17","is water":true,"is conflict":true,"num dead":1},{"startDate":"2010-05-18","is water":true,"is conflict":true,"num dead":1},{"startDate":"2010-04-01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2010-04-01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2010-03-21","is water":true,"num suicide":19}],"2011":[{"startDate":"2011-08-09","is water":true,"is protest":true,"is conflict":true,"num dead":3},{"startDate":"2011-05-01","is water":true,"num suicide":6}],"2012":[{"startDate":"2012-01-06","is water":true,"is riot":true,"is conflict":true,"num dead":1,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/howrah","title":"Water brawl in West Bengal, India, 19 June 2012","summary":"The city of Howrah in West Bengal, has been facing water shortages resulting in high levels of regional resource insecurity spurring on civil unrest. Kazipara Village demonstrated this trend on 19 June 2012. Here, Sirajuddin Mullick was killed by his neighbours over water being distributed by the Howrah Municipal Corporation (HMC) tanker.","city":"Howrah","village":"Kazipara"}},{"startDate":"2012-05-01","is water":true,"is protest":true,"is conflict":true,"num injured":4,"num dead":1},{"startDate":"2012-08-01","is water":true,"num suicide":10}],"2013":[{"startDate":"2013-03-01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2013-01-01","is water":true,"num suicide":1},{"startDate":"2013-01-20","is water":true,"num suicide":1}],"2014":[{"startDate":"2014-04-01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2014-06-02","is water":true,"num suicide":1}],"2015":[{"startDate":"2015-04-01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2015/08/01","is water":true,"num suicide":1},{"startDate":"2015-10-08","is water":true,"num suicide":66}],"2016":[{"startDate":"2016-09-12","is water":true,"is protest":true,"is riot":true,"is conflict":true,"num arrests":200,"num dead":1},{"startDate":"2016-02-01","is water":true,"is riot":true,"num dead":30},{"startDate":"2016-06-22","is water":true,"is looting":true,"is conflict":true,"num dead":1},{"startDate":"2016-03-27","is water":true,"num suicide":9},{"startDate":"2016/05/01","is water":true,"is conflict":true,"num dead":1},{"startDate":"2016-05-27","is water":true,"is conflict":true,"num dead":1},{"startDate":"2016-01-01","is water":true,"num suicide":89},{"startDate":"2016-02-01","is water":true,"num suicide":79}],"2017":[{"startDate":"2017-06-01","is water":true,"is looting":true,"is conflict":true,"num dead":2},{"startDate":"2017-03-01","is water":true,"is conflict":true,"num arrests":1,"num dead":1},{"startDate":"2017-06-01","is water":true,"num suicide":6},{"startDate":"2017-01-01","is water":true,"num suicide":17}]}},"gtm":{"name":"Guatemala","total":{"num participants":5000,"num injured":6,"num dead":5},"totalByYear":{"2013":{"num participants":5000,"num injured":6,"num dead":5}},"eventsByYear":{"2013":[{"startDate":"2013-01-11","is water":true,"is protest":true,"is conflict":true,"num participants":5000,"num injured":6,"num dead":5}]}},"nga":{"name":"Nigeria","total":{"num injured":37,"num dead":10,"num participants":2000},"totalByYear":{"2012":{"num dead":7,"num participants":2000,"num injured":33},"2013":{"num injured":4,"num dead":2},"2016":{"num dead":1}},"eventsByYear":{"2012":[{"startDate":"2012-02-01","is fuel":true,"is demo":true,"num dead":1},{"startDate":"2012-09-01","is fuel":true,"is protest":true,"num participants":1000,"num injured":3,"num dead":1},{"startDate":"2012-09-01","is fuel":true,"is protest":true,"num participants":1000,"num injured":30,"num dead":2},{"startDate":"2012-01-10","is fuel":true,"is protest":true,"num dead":2},{"startDate":"2012-01-10","is fuel":true,"is protest":true,"num dead":1}],"2013":[{"startDate":"2013-02-25","is water":true,"is riot":true,"num injured":4,"num dead":2}],"2016":[{"startDate":"2016-04-11","is fuel":true,"is protest":true,"num dead":1}]}},"sdn":{"name":"Sudan","total":{"num participants":100,"num arrests":100,"num dead":88},"totalByYear":{"2008":{"num dead":51},"2012":{"num dead":6},"2013":{"num dead":30},"2014":{"num participants":100,"num arrests":100,"num dead":1}},"eventsByYear":{"2008":[{"startDate":"2008-08-20","is water":true,"is conflict":true,"num dead":50},{"startDate":"2008-08-01","is food":true,"is riot":true,"num dead":1}],"2012":[{"startDate":"2012-07-31","is fuel":true,"is protest":true,"num dead":6}],"2013":[{"startDate":"2013-09-23","is fuel":true,"is demo":true,"is riot":true,"num dead":30,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/sudan","title":"Hundreds Dead in Sudan’s 2013 Fuel Price Hike Protests","summary":"Confirmation of fuel subsidy cuts by the Sudanese government on the 23rd of September 2013 sparked civilian outrage. The decision was the combined outcome of crude oil revenue loss from the secession of South Sudan in 2011, exacerbated further by US economic sanctions over President al-Bashir’s war crimes."}}],"2014":[{"startDate":"2014-06-01","is water":true,"is protest":true,"num participants":100,"num arrests":100,"num dead":1}]}},"irn":{"name":"Iran","total":{"num dead":5},"totalByYear":{"2013":{"num dead":5}},"eventsByYear":{"2013":[{"startDate":"2013-02-28","is water":true,"is riot":true,"num dead":5}]}},"zwe":{"name":"Zimbabwe","total":{"num dead":6},"totalByYear":{"2005":{"num dead":1},"2015":{"num dead":5}},"eventsByYear":{"2005":[{"startDate":"2005-11-01","is water":true,"is riot":true,"num dead":1}],"2015":[{"startDate":"2015-03-09","is food":true,"is riot":true,"num dead":5}]}},"mli":{"name":"Mali","total":{"num injured":5,"num dead":1},"totalByYear":{"2008":{"num injured":5,"num dead":1}},"eventsByYear":{"2008":[{"startDate":"2008","is water":true,"is protest":true,"num injured":5,"num dead":1}]}},"isr":{"name":"Israel","total":{"num dead":5},"totalByYear":{"2014":{"num dead":5}},"eventsByYear":{"2014":[{"startDate":"2014-07-01","is water":true,"is conflict":true,"num dead":5}]}},"tza":{"name":"Tanzania","total":{"num dead":8},"totalByYear":{"2008":{"num dead":8}},"eventsByYear":{"2008":[{"startDate":"2008-01-01","is water":true,"is protest":true,"is conflict":true,"num dead":8}]}},"per":{"name":"Peru","total":{"num dead":3},"totalByYear":{"2011":{"num dead":3}},"eventsByYear":{"2011":[{"startDate":"2011","is water":true,"is protest":true,"num dead":3}]}},"irq":{"name":"Iraq","total":{"num participants":1000,"num injured":50,"num dead":6},"totalByYear":{"2005":{"num participants":1000,"num injured":50,"num dead":6}},"eventsByYear":{"2005":[{"startDate":"2005-08-01","is water":true,"is protest":true,"is riot":true,"num participants":1000,"num injured":50,"num dead":1},{"startDate":"2005-12-01","is fuel":true,"is riot":true,"num dead":5}]}},"pak":{"name":"Pakistan","total":{"num injured":31,"num dead":20},"totalByYear":{"2009":{"num injured":30,"num dead":18},"2016":{"num injured":1,"num dead":2}},"eventsByYear":{"2009":[{"startDate":"2009-09-14","is food":true,"is riot":true,"is conflict":true,"num injured":30,"num dead":18}],"2016":[{"startDate":"2016-06-18","is water":true,"is protest":true,"is conflict":true,"num injured":1,"num dead":2}]}},"yem":{"name":"Yemen","total":{"num injured":5,"num dead":149,"num participants":10000},"totalByYear":{"2008":{"num dead":12},"2009":{"num injured":3,"num dead":1},"2011":{"num participants":10000,"num dead":130},"2013":{"num dead":2},"2014":{"num injured":2,"num dead":4}},"eventsByYear":{"2008":[{"startDate":"2008-04-01","is food":true,"is riot":true,"num dead":12}],"2009":[{"startDate":"2009-08-02","is water":true,"is demo":true,"is protest":true,"num injured":3,"num dead":1}],"2011":[{"startDate":"2011-05-01","is fuel":true,"is protest":true,"is conflict":true,"num participants":10000,"num dead":130}],"2013":[{"startDate":"2013-03-22","is water":true,"is protest":true,"num dead":2,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/taiz","title":"Yemeni Water Shortage Compounds Country’s Instability","summary":"Yemen’s decades of political instability, exacerbated by ecological crises, has resulted in a complexityof problems for the country. As one of the poorest Arab countries, Yemen is also one of the driest, with access to only 140m3 of groundwater annually, where the Middle Eastern average is 1,000m3 a year. Predicted to be the first nation in the world to run out of water, Yemen’s water crisis is a significant casualty of failed governance and environmental mismanagement.","city":"Taiz"}}],"2014":[{"startDate":"2014-05-31","is fuel":true,"is conflict":true,"num injured":2,"num dead":1},{"startDate":"2014-06-01","is fuel":true,"is conflict":true,"num dead":1},{"startDate":"2014-06-02","is fuel":true,"is conflict":true,"num dead":1},{"startDate":"2014-06-03","is fuel":true,"is conflict":true,"num dead":1}]}},"tjk":{"name":"Tajikistan","total":{"num dead":1},"totalByYear":{"2015":{"num dead":1}},"eventsByYear":{"2015":[{"startDate":"2015-07-01","is water":true,"is conflict":true,"num dead":1}]}},"lbn":{"name":"Lebanon","total":{"num participants":4,"num injured":1,"num dead":2},"totalByYear":{"2016":{"num participants":4,"num injured":1,"num dead":2}},"eventsByYear":{"2016":[{"startDate":"2016-12-01","is water":true,"is conflict":true,"num participants":4,"num injured":1,"num dead":2}]}},"aus":{"name":"Australia","total":{"num injured":2,"num suicide":6,"num dead":1},"totalByYear":{"2005":{"num suicide":3},"2006":{"num injured":2,"num suicide":3},"2007":{"num dead":1}},"eventsByYear":{"2005":[{"startDate":"2005-09-01","is fuel":true,"num suicide":3}],"2006":[{"startDate":"2006-09-01","is water":true,"num injured":2,"num suicide":3}],"2007":[{"startDate":"2007-10-31","is water":true,"is conflict":true,"num dead":1}]}},"gin":{"name":"Guinea","total":{"num dead":11},"totalByYear":{"2006":{"num dead":11}},"eventsByYear":{"2006":[{"startDate":"2006-06-08","is fuel":true,"is riot":true,"num dead":11}]}},"mwi":{"name":"Malawi","total":{"num dead":18},"totalByYear":{"2011":{"num dead":18}},"eventsByYear":{"2011":[{"startDate":"2011-07-20","is fuel":true,"is looting":true,"is protest":true,"num dead":18}]}},"mex":{"name":"Mexico","total":{"num arrests":700,"num dead":4},"totalByYear":{"2017":{"num arrests":700,"num dead":4}},"eventsByYear":{"2017":[{"startDate":"2017-02-01","is fuel":true,"is looting":true,"is riot":true,"num arrests":700,"num dead":4}]}},"prt":{"name":"Portugal","total":{"num participants":1000,"num dead":1},"totalByYear":{"2008":{"num participants":1000,"num dead":1}},"eventsByYear":{"2008":[{"startDate":"2008-06-10","is fuel":true,"is demo":true,"num participants":1000,"num dead":1}]}},"esp":{"name":"Spain","total":{"num participants":1000,"num dead":1},"totalByYear":{"2008":{"num participants":1000,"num dead":1}},"eventsByYear":{"2008":[{"startDate":"2008-06-11","is fuel":true,"is demo":true,"num participants":1000,"num dead":1}]}},"bgr":{"name":"Bulgaria","total":{"num suicide":1,"num dead":1},"totalByYear":{"2013":{"num suicide":1,"num dead":1}},"eventsByYear":{"2013":[{"startDate":"2013-02-20","is fuel":true,"num suicide":1},{"startDate":"2013-02-02","is fuel":true,"is protest":true,"num dead":1}]}},"cmr":{"name":"Cameroon","total":{"num dead":60},"totalByYear":{"2008":{"num dead":60}},"eventsByYear":{"2008":[{"startDate":"2008-02-25","is fuel":true,"is riot":true,"num dead":20},{"startDate":"2008-01-01","is food":true,"is riot":true,"num dead":40}]}},"tgo":{"name":"Togo","total":{"num injured":5,"num dead":1},"totalByYear":{"2017":{"num injured":5,"num dead":1}},"eventsByYear":{"2017":[{"startDate":"2017-03-28","is fuel":true,"is protest":true,"is riot":true,"num injured":5,"num dead":1}]}},"uga":{"name":"Uganda","total":{"num arrests":105,"num injured":110,"num dead":11},"totalByYear":{"2011":{"num arrests":105,"num injured":110,"num dead":11}},"eventsByYear":{"2011":[{"startDate":"2011-01-04","is food":true,"is fuel":true,"is demo":true,"num arrests":104,"num injured":10,"num dead":4},{"startDate":"2011-04-21","is food":true,"is demo":true,"is riot":true,"num arrests":1,"num injured":100,"num dead":5},{"startDate":"2011-04-21","is food":true,"is demo":true,"is riot":true,"num dead":2}]}},"chn":{"name":"China","total":{"num dead":4,"num injured":31},"totalByYear":{"2007":{"num dead":4,"num injured":31}},"eventsByYear":{"2007":[{"startDate":"2007-11-01","is fuel":true,"is conflict":true,"num dead":1},{"startDate":"2007-11-01","is food":true,"is conflict":true,"num injured":31,"num dead":3}]}},"egy":{"name":"Egypt","total":{"num dead":23,"num arrests":400},"totalByYear":{"2008":{"num arrests":400,"num dead":15},"2010":{"num dead":1},"2013":{"num dead":7}},"eventsByYear":{"2008":[{"startDate":"2008-04-06","is food":true,"is protest":true,"is riot":true,"num arrests":400,"num dead":2,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/cairo","title":"Food and fuel subsidy cuts and the IMF policy-based lending: a traditional recipe for Egypt’s social unrest","summary":"Associated with two separate loan agreements with the IMF, the inflationary pressure driven by food and fuel subsidy cuts is a common suspect behind Egypt’s wide-scale social unrest in 1977 and around 2011.","city":"El Mahalla El-Kubra"}},{"startDate":"2008-03-01","is food":true,"is protest":true,"is riot":true,"num dead":10},{"startDate":"2008-04-07","is food":true,"is protest":true,"is riot":true,"num dead":1},{"startDate":"2008-08-02","is food":true,"is conflict":true,"num dead":2}],"2010":[{"startDate":"2010-08-01","is food":true,"is protest":true,"num dead":1,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/cairo","title":"Food and fuel subsidy cuts and the IMF policy-based lending: a traditional recipe for Egypt’s social unrest","summary":"Associated with two separate loan agreements with the IMF, the inflationary pressure driven by food and fuel subsidy cuts is a common suspect behind Egypt’s wide-scale social unrest in 1977 and around 2011."}}],"2013":[{"startDate":"2013-06-23","is fuel":true,"is conflict":true,"num dead":5,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/cairo","title":"Food and fuel subsidy cuts and the IMF policy-based lending: a traditional recipe for Egypt’s social unrest","summary":"Associated with two separate loan agreements with the IMF, the inflationary pressure driven by food and fuel subsidy cuts is a common suspect behind Egypt’s wide-scale social unrest in 1977 and around 2011."}},{"startDate":"2013-06-25","is fuel":true,"is conflict":true,"num dead":2}]}},"npl":{"name":"Nepal","total":{"num dead":1},"totalByYear":{"2015":{"num dead":1}},"eventsByYear":{"2015":[{"startDate":"2015-11-01","is fuel":true,"is demo":true,"num dead":1}]}},"bgd":{"name":"Bangladesh","total":{"num dead":4},"totalByYear":{"2006":{"num dead":2},"2008":{"num dead":2}},"eventsByYear":{"2006":[{"startDate":"2006-05-05","is water":true,"is fuel":true,"is protest":true,"num dead":2}],"2008":[{"startDate":"2008-04-14","is food":true,"is conflict":true,"num dead":2}]}},"kor":{"name":"South Korea","total":{"num suicide":3,"num injured":4000},"totalByYear":{"2005":{"num suicide":3,"num injured":4000}},"eventsByYear":{"2005":[{"startDate":"2005-09-01","is fuel":true,"is protest":true,"num suicide":1},{"startDate":"2005-11-01","is food":true,"is protest":true,"num injured":4000,"num suicide":2}]}},"hti":{"name":"Haiti","total":{"num dead":5},"totalByYear":{"2008":{"num dead":5}},"eventsByYear":{"2008":[{"startDate":"2008-04-01","is food":true,"is demo":true,"is protest":true,"is riot":true,"num dead":5}]}},"dza":{"name":"Algeria","total":{"num injured":400,"num dead":2},"totalByYear":{"2011":{"num injured":400,"num dead":2}},"eventsByYear":{"2011":[{"startDate":"2011-01-04","is food":true,"is demo":true,"is protest":true,"is riot":true,"num injured":400,"num dead":2}]}},"ven":{"name":"Venezuela","total":{"num injured":175,"num dead":103,"num participants":200,"num arrests":4500},"totalByYear":{"2015":{"num dead":1},"2016":{"num injured":171,"num dead":10},"2017":{"num participants":200,"num injured":4,"num dead":92,"num arrests":4500}},"eventsByYear":{"2015":[{"startDate":"2015-08-24","is food":true,"is riot":true,"num dead":1}],"2016":[{"startDate":"2016-06-14","is food":true,"is looting":true,"is protest":true,"is riot":true,"num injured":150,"num dead":2,"commentary":{"url":"https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/northern-venezuela","title":"2016 Venezuelan Oil Price Collapse Escalates Into Violent Starvation","summary":"The northern region of Venezuela, particularly the state of Sucre and district capital Caracas, were gripped by violence and death in the summer of 2016. The unrest, a result of the steep fall in Venezuelan oil prices, led to severe shortages in food and basic necessities, as imports became unaffordable.","city":"Cumana"}},{"startDate":"2016-06-15","is food":true,"is looting":true,"is protest":true,"num dead":1},{"startDate":"2016-06-14","is food":true,"is conflict":true,"num injured":8,"num dead":1},{"startDate":"2016-06-16","is food":true,"is protest":true,"num injured":11,"num dead":1},{"startDate":"2016-06-06","is food":true,"is protest":true,"num dead":1},{"startDate":"2016-06-06","is food":true,"is protest":true,"num injured":1,"num dead":1},{"startDate":"2016-06-06","is food":true,"is protest":true,"num injured":1,"num dead":1},{"startDate":"2016-05-11","is food":true,"is riot":true,"num dead":2}],"2017":[{"startDate":"2017-09-22","is food":true,"is protest":true,"num participants":200,"num injured":4,"num dead":2},{"startDate":"2017-04-01","is food":true,"is demo":true,"is looting":true,"is protest":true,"is riot":true,"is conflict":true,"num arrests":4500,"num dead":90}]}},"som":{"name":"Somalia","total":{"num participants":20000,"num dead":12},"totalByYear":{"2008":{"num participants":20000,"num dead":5},"2011":{"num dead":7}},"eventsByYear":{"2008":[{"startDate":"2008-05-05","is food":true,"is riot":true,"num participants":20000,"num dead":5}],"2011":[{"startDate":"2011-08-05","is food":true,"is conflict":true,"num dead":7}]}},"civ":{"name":"Cote d'Ivoire","total":{"num injured":10,"num dead":1},"totalByYear":{"2008":{"num injured":10,"num dead":1}},"eventsByYear":{"2008":[{"startDate":"2008-04-24","is food":true,"is riot":true,"num injured":10,"num dead":1}]}},"mrt":{"name":"Mauritania","total":{"num dead":1},"totalByYear":{"2007":{"num dead":1}},"eventsByYear":{"2007":[{"startDate":"2007-11-01","is food":true,"is looting":true,"is riot":true,"num dead":1}]}},"phl":{"name":"Philippines","total":{"num dead":3},"totalByYear":{"2016":{"num dead":3}},"eventsByYear":{"2016":[{"startDate":"2016-04-01","is food":true,"is protest":true,"num dead":3}]}},"tun":{"name":"Tunisia","total":{"num dead":100},"totalByYear":{"2011":{"num dead":100}},"eventsByYear":{"2011":[{"startDate":"2011-01-01","is food":true,"is protest":true,"num dead":100}]}},"ner":{"name":"Niger","total":{"num suicide":2},"totalByYear":{"2005":{"num suicide":2}},"eventsByYear":{"2005":[{"startDate":"2005-07-01","is food":true,"num suicide":2}]}},"moz":{"name":"Mozambique","total":{"num injured":300,"num dead":10},"totalByYear":{"2010":{"num injured":300,"num dead":10}},"eventsByYear":{"2010":[{"startDate":"2010-09-01","is food":true,"is protest":true,"is riot":true,"is conflict":true,"num injured":300,"num dead":10}]}}}

/***/ }),

/***/ "I9DM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("EBst");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./node_modules/preact-router/dist/preact-router.es.js


var EMPTY$1 = {};

function preact_router_es_assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var preact_router_es_Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					preact_router_es_assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(preact_min["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(preact_min["Component"]);

var preact_router_es_Link = function Link(props) {
	return Object(preact_min["h"])('a', preact_router_es_assign({ onClick: handleLinkClick }, props));
};

var preact_router_es_Route = function Route(props) {
	return Object(preact_min["h"])(props.component, props);
};

preact_router_es_Router.subscribers = subscribers;
preact_router_es_Router.getCurrentUrl = getCurrentUrl;
preact_router_es_Router.route = route;
preact_router_es_Router.Router = preact_router_es_Router;
preact_router_es_Router.Route = preact_router_es_Route;
preact_router_es_Router.Link = preact_router_es_Link;

/* harmony default export */ var preact_router_es = (preact_router_es_Router);
//# sourceMappingURL=preact-router.es.js.map
// CONCATENATED MODULE: ./lib/utils.js


function get(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
      if (xhr.status >= 400 && xhr.status < 600) {
        reject(new Error('Could not get data, ' + xhr.status + ' ' + xhr.statusText));
      }

      resolve(xhr);
    };

    xhr.onerror = reject;

    xhr.open('get', url, true);
    xhr.send();
  });
}

var JSON_FILENAME = /\.json(?:[\?#].*)?$/;

function fetch(url) {
  return get(url).then(function (xhr) {
    return xhr.responseXML && xhr.responseXML.childNodes || xhr.responseText;
  }).then(function (data) {
    if (JSON_FILENAME.test(url)) {
      try {
        data = JSON.parse(data);
      } catch (err) {
        console.warn('Could not parse data as JSON', url);
      }
    }

    return data;
  });
}

var COUNTRY_YEAR_PATHNAME = /^\/([a-z]{3})?\/?(\d{4})?\/?/;

function currentPath() {
  var path = typeof window === 'undefined' ? getCurrentUrl() : window.location.pathname;

  return parsePath(path);
}

function parsePath(path) {
  var _path$match = path.match(COUNTRY_YEAR_PATHNAME),
      _path$match$ = _path$match[1],
      countryId = _path$match$ === undefined ? null : _path$match$,
      _path$match$2 = _path$match[2],
      year = _path$match$2 === undefined ? null : _path$match$2;

  return { countryId: countryId, year: year && Number(year) };
}

function setRoute(year, countryId, replace) {
  // Auto-replace if no change to country, only a change to year
  if (typeof replace !== 'boolean') {
    var path = currentPath();
    replace = countryId === path.countryId && year && path.year || false;
  }

  var url = '';

  if (countryId) {
    url += '/' + countryId;
  }

  if (year) {
    url += '/' + year;
  }

  // console.log({year, countryId, url});

  route(url || '/', replace);
}

function getValueGrouping(value) {
  if (value === 0) {
    return '0';
  }

  if (value === 1) {
    return '1';
  }

  if (value < 4) {
    return '2-3';
  }

  if (value < 21) {
    return '4-20';
  }

  if (value < 51) {
    return '21-50';
  }

  return '51+';
}
// EXTERNAL MODULE: ./lib/worldmap.css
var worldmap = __webpack_require__("CvhG");
var worldmap_default = /*#__PURE__*/__webpack_require__.n(worldmap);

// EXTERNAL MODULE: ./lib/worldmap-layout.css
var worldmap_layout = __webpack_require__("xKUf");
var worldmap_layout_default = /*#__PURE__*/__webpack_require__.n(worldmap_layout);

// EXTERNAL MODULE: ./lib/worldmap-media-queries.css
var worldmap_media_queries = __webpack_require__("I9DM");
var worldmap_media_queries_default = /*#__PURE__*/__webpack_require__.n(worldmap_media_queries);

// CONCATENATED MODULE: ./lib/panzoom.js
if (!Math.hypot) {
  Math.hypot = function () {
    var y = 0,
        i = arguments.length;
    while (i--) {
      y += arguments[i] * arguments[i];
    }return Math.sqrt(y);
  };
}

/* harmony default export */ var panzoom = ((function (window, document) {
  if (!window) {
    return function () {};
  }

  // var passiveEventsSupported = false;

  // try {
  //   window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { passiveEventsSupported = { passive: true }; } }));
  // }

  // catch(err) {}


  var wheelEventName = 'onwheel' in document.body ? 'wheel' : document.onmousewheel ? 'mousewheel' : 'DOMMouseScroll';

  function _addWheelListener(elem, wheelEventName, callback, useCapture) {
    // Modified from
    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel

    var listener;

    if (wheelEventName === 'wheel') {
      listener = callback;
    } else {
      listener = function listener(originalEvent) {
        // normalized event object
        var event = {
          originalEvent: originalEvent,
          target: originalEvent.target || originalEvent.srcElement,
          type: 'wheel',
          deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
          deltaX: 0,
          deltaY: 0,
          deltaZ: 0,
          preventDefault: function preventDefault() {
            if (originalEvent.preventDefault) {
              originalEvent.preventDefault();
            } else {
              originalEvent.returnValue = false;
            }
          }
        };

        if (wheelEventName === 'mousewheel') {
          event.deltaY = -1 / 40 * originalEvent.wheelDelta;

          if (originalEvent.wheelDeltaX) {
            event.deltaX = -1 / 40 * originalEvent.wheelDeltaX;
          }
        } else {
          event.deltaY = originalEvent.deltaY || originalEvent.detail;
        }

        return callback(event);
      };
    }

    elem.addEventListener(wheelEventName, listener, useCapture || false);
  }

  function addWheelListener(elem, callback, useCapture) {
    // older Firefox
    if (wheelEventName === 'DOMMouseScroll') {
      _addWheelListener(elem, 'MozMousePixelScroll', callback, useCapture);
    } else {
      _addWheelListener(elem, wheelEventName, callback, useCapture);
    }
  }

  function getElement(selectorOrElement) {
    if (typeof selectorOrElement === 'string') {
      return document.querySelector(selectorOrElement);
    }

    if (selectorOrElement instanceof HTMLElement || selectorOrElement instanceof SVGElement) {
      return selectorOrElement;
    }

    return null;
  }

  function dimensions(elem) {
    var x = 0;
    var y = 0;
    var width = 0;
    var height = 0;

    if (elem instanceof HTMLElement) {
      x = elem.offsetLeft;
      y = elem.offsetTop;
      width = elem.offsetWidth;
      height = elem.offsetHeight;

      // console.log('parent', { width, height, elem});
    } else if (elem instanceof SVGElement) {
      var bbox;

      try {
        if (elem.nodeName === 'tspan') {
          bbox = elem.getBoundingClientRect(); // getComputedTextLength
        }

        // else if (elem.nodeName === 'svg' && elem.width && elem.height) {
        //   var widthVal = elem.width.baseVal;
        //   var heightVal = elem.height.baseVal;
        //   var parentDimensions, width, height;

        //   if (widthVal.valueAsString.endsWith('%')) {
        //     parentDimensions = dimensions(elem.parentNode);
        //     width = parentDimensions.width * parseInt(widthVal.valueAsString) / 100;
        //   }

        //   else {
        //     width = widthVal.value;
        //   }

        //   if (heightVal.valueAsString.endsWith('%')) {
        //     if (!parentDimensions) {
        //       parentDimensions = dimensions(elem.parentNode);
        //     }

        //     height = parentDimensions.height * parseInt(heightVal.valueAsString) / 100;
        //   }

        //   else {
        //     height = heightVal.value;
        //   }

        //   console.log({width, height, widthVal, heightVal, parentDimensions});

        //   return {
        //     width,
        //     height
        //   };
        // }

        else {
            bbox = elem.getBBox();
          }

        x = bbox.x || bbox.left;
        y = bbox.y || bbox.top;
        width = bbox.width;
        height = bbox.height;
      } catch (err) {}
    }

    return {
      x: x,
      y: y,
      width: width,
      height: height
    };
  }

  // function innerSize (elem, _maxSize) {
  //   var size = dimensions(elem);

  //   if (_maxSize && _maxSize.width * _maxSize.height > size.width * size.height) {
  //     size = _maxSize;
  //   }

  //   var children = Array.prototype.slice.apply(elem.childNodes)
  //     .filter(function (child) {
  //       return child.nodeType === 1;
  //     });

  //   children.forEach(function (child) {
  //     var childSize = innerSize(child, size);

  //     if (childSize.width * childSize.height > size.width * size.height) {
  //       size = childSize;
  //     }
  //   });

  //   return size;
  // }

  function setTransform(elem, transformProperty, value, priority) {
    // console.log('setTransform', { elem, transformProperty, value, priority });

    var transformFunction = transformProperty + '(' + value + ')';
    var currentTransform = elem.style.transform;
    var newTransform;

    if (!currentTransform) {
      newTransform = transformFunction;
    } else {
      var propertyIndex = currentTransform.indexOf(transformProperty);

      if (propertyIndex === -1) {
        // prioritise translate
        if (transformProperty === 'translate') {
          newTransform = transformFunction + ' ' + currentTransform;
        } else {
          newTransform = currentTransform + ' ' + transformFunction;
        }
      } else {
        var propertyEndIndex = currentTransform.slice(propertyIndex).indexOf(')');
        var currentTransformStart = currentTransform.slice(0, propertyIndex);
        var currentTransformEnd = currentTransform.slice(propertyIndex + propertyEndIndex + 1);

        newTransform = currentTransformStart + ' ' + transformFunction + currentTransformEnd;
      }
    }

    // console.log(newTransform);

    if (newTransform && newTransform !== currentTransform) {
      elem.style.transform = newTransform;
    }
  }

  function translate(elem, options) {
    var dx, dy;

    if (options.constrain === true) {
      var constrained = constrain(options);

      dx = constrained.dx;
      dy = constrained.dy;
    } else {
      dx = options.dx;
      dy = options.dy;
    }

    setTransform(elem, 'translate', dx + 'px,' + dy + 'px');

    return { dx: dx, dy: dy };
  }

  function constrain(options) {
    var dx = options.dx;
    var dy = options.dy;
    var width = options.width;
    var height = options.height;
    var viewportWidth = options.viewportWidth || width;
    var viewportHeight = options.viewportHeight || height;
    var scale = options.scale || 1;

    var newDx;
    var newDy;

    var allowedOffsetLeft = -(scale * width - viewportWidth);
    var allowedOffsetRight = 0;

    if (allowedOffsetRight < allowedOffsetLeft) {
      allowedOffsetRight = allowedOffsetLeft;
      allowedOffsetLeft = 0;
    }

    var allowedOffsetTop = 0;
    var allowedOffsetBottom = -(scale * height - viewportHeight);

    if (allowedOffsetBottom < allowedOffsetTop) {
      allowedOffsetTop = allowedOffsetBottom;
      allowedOffsetBottom = 0;
    }

    if (dx < allowedOffsetLeft) {
      newDx = (allowedOffsetLeft - dx) / 2 + dx;

      if (newDx < allowedOffsetLeft) {
        newDx = allowedOffsetLeft;
      }
    } else if (dx > allowedOffsetRight) {
      newDx = dx - (dx - allowedOffsetRight) / 2 + dx;

      if (newDx > allowedOffsetRight) {
        newDx = allowedOffsetRight;
      }
    }

    if (dy < allowedOffsetTop) {
      newDy = (allowedOffsetTop - dy) / 2 + dy;

      if (newDy < allowedOffsetTop) {
        newDy = allowedOffsetTop;
      }
    } else if (dy > allowedOffsetBottom) {
      newDy = dy - (dy - allowedOffsetBottom) / 2 + dy;

      if (newDy > allowedOffsetBottom) {
        newDy = allowedOffsetBottom;
      }
    }

    return { dx: newDx, dy: newDy };
  }

  function animateWhile(fn) {
    return new Promise(function (resolve) {
      requestAnimationFrame(function loop() {
        if (fn() === true) {
          requestAnimationFrame(loop);
        } else {
          resolve();
        }
      });
    });
  }

  /////

  function PanZoom(selectorOrElement, options) {
    this.elem = getElement(selectorOrElement);

    if (!this.elem) {
      throw new Error('panzoom: No such element ' + selectorOrElement);
    }

    options || (options = {});

    this.autosize = options.autosize || false;
    this.ctrlKeyToPan = options.ctrlKeyToPan || false;
    this.paddingLeft = options.paddingLeft || 0;
    this.paddingRight = options.paddingRight || 0;
    this.paddingTop = options.paddingTop || 0;
    this.paddingBottom = options.paddingBottom || 0;
    this.zoomMinDefault = options.zoomMin || 0.25;
    this.zoomMin = this.zoomMinDefault;
    this.zoomMax = options.zoomMax || 1.5;
    this.zoomIncrement = options.zoomIncrement || 0.1;
    this.zoomSpeed = options.zoomSpeed || 250;
    this.zoomType = options.zoomType || 'pixel'; // pixel or spin in wheel data
    // this.zoomControl = getElement(options.zoomControl);
    // this.zoomInButton = getElement(options.zoomInButton);
    // this.zoomOutButton = getElement(options.zoomOutButton);
    this.zoomDelegate = getElement(options.zoomDelegate) || this.elem.parentNode;
    this.panDelegate = getElement(options.panDelegate) || this.elem.parentNode;
    this.panTransitionIncrement = options.panTransitionIncrement || 0.1;
    this.zoomTransitionIncrement = options.zoomTransitionIncrement || 0.05;
    this.panGutterLeft = options.panGutterLeft || null;
    this.panGutterRight = options.panGutterRight || null;

    this.currentScale = 1;
    this.viewportFocusXRatio = 0.5;
    this.viewportFocusYRatio = 0.5;
    this.imageOriginX = 0;
    this.imageOriginY = 0;
    this.dx = 0;
    this.dy = 0;
    this.offsetX = 0;
    this.offsetY = 0;
    this.panStartX = null;
    this.panStartY = null;
    this.panStartPageX = null;
    this.panStartPageY = null;
    this.pinchZoom = null;
    this.pinchDirection = [];
    this.waitingForAnimation = false;
    this.omitSmallShapes = options.omitSmallShapes || false;
    this.constrain = options.constrain || false;

    var imageSize = dimensions(this.elem);
    this.width = imageSize.width;
    this.height = imageSize.height;
    this.aspectRatio = this.width / this.height;
    this.viewBox = this.getViewBox();

    // this.left = imageSize.x + (this.viewBox[0] || 0);
    // this.top = imageSize.y + (this.viewBox[1] || 0);
    // this.captureDimensions();

    this.pan = this.pan.bind(this);
    this.panStart = this.panStart.bind(this);
    this.panStop = this.panStop.bind(this);
    this.panWaitForReenter = this.panWaitForReenter.bind(this);
    this.panResume = this.panResume.bind(this);
    this.resize = this.resize.bind(this);
    this._getScale = this._getScale.bind(this);
    this._getOffset = this._getOffset.bind(this);
    this._getZoomRange = this._getZoomRange.bind(this);

    this.on = {
      scale: [],
      offset: [],
      resize: [],
      click: []
    };

    this.initializeStyles();
    this.initializePan();
    this.initializeZoom();

    // var aspectRatio = this.width / this.height;

    // console.log('init', this.viewportWidth, this.viewportHeight, this.width, this.height, aspectRatio);

    this.setViewportOriginRatio(0.5, 0.5);
  }

  PanZoom.prototype = {
    constructor: PanZoom,

    getViewBox: function getViewBox() {
      if (!(this.elem instanceof SVGElement)) {
        return [];
      }

      var attr = this.elem.getAttribute('viewBox');

      if (!attr) {
        return [];
      }

      return attr.split(/\s+|\s*,/).map(Number);
    },

    captureDimensions: function captureDimensions() {
      // var imageSize = dimensions(this.elem);
      var parentSize = dimensions(this.elem.parentNode);

      this.viewportWidth = parentSize.width;
      this.viewportHeight = parentSize.height;

      var _getPadding = this.getPadding(),
          paddingLeft = _getPadding.paddingLeft,
          paddingRight = _getPadding.paddingRight,
          paddingTop = _getPadding.paddingTop,
          paddingBottom = _getPadding.paddingBottom;

      this.defaultScale = Math.min(this.viewportWidth / (this.width + paddingLeft + paddingRight), this.viewportHeight / (this.height + paddingTop + paddingBottom));

      // Apply zoomMin in constructor options, if they are greater
      this.zoomMin = Math.max(this.defaultScale, this.zoomMinDefault);

      // console.log('captureDimensions', { defaultScale: this.defaultScale, zoomMin: this.zoomMin, zoomMinDefault: this.zoomMinDefault, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight, imageWidth: this.width, imageHeight: this.height, paddingLeft, paddingRight, paddingTop, paddingBottom });


      // console.log('dim', { elem: [this.width, this.height], aspect: this.aspectRatio, defaultScale: this.defaultScale, parent: [this.viewportWidth, this.viewportHeight], box: [this.boxWidth, this.boxHeight]});
    },

    initializeStyles: function initializeStyles() {
      var style = this.elem.style;
      var parentStyle = this.elem.parentNode.style;

      // for zoom
      // style.transformOrigin = '50% 50%';
      style.transformOrigin = '0 0';
      // style.transition = 'transform-origin 0.38s ease-in';
      parentStyle.overflow = 'hidden';

      if (this.zoomInButton) {
        this.zoomInButton.style.cursor = 'zoom-in';
      }

      if (this.zoomOutButton) {
        this.zoomOutButton.style.cursor = 'zoom-out';
      }

      // for pan
      style.cursor = 'drag';
    },

    scale: function scale(newScale) {
      // console.log('scale', { newScale, currentScale: this.currentScale, zoomMin: this.zoomMin, zoomMax: this.zoomMax })

      if (newScale < this.zoomMin) {
        newScale = this.zoomMin;
      } else if (newScale > this.zoomMax) {
        newScale = this.zoomMax;
      }

      if (newScale === this.currentScale) {
        return;
      }

      this.currentScale = newScale;
      this.updateTransform();

      if (this.constrain) {
        this.panRefresh();
      }

      if (this.updateZoomControl) {
        this.updateZoomControl();
      }
    },

    scaleSquare: function scaleSquare(scale) {
      var zoomMin = this.zoomMin,
          zoomMax = this.zoomMax;

      var range = zoomMax - zoomMin;
      var valueRatio = (scale - zoomMin) / range;
      var adjustedRatio = valueRatio * valueRatio;
      var adjustedScale = adjustedRatio * range + zoomMin;

      return adjustedScale;
    },
    scaleSquareRoot: function scaleSquareRoot(adjustedScale) {
      var zoomMin = this.zoomMin,
          zoomMax = this.zoomMax;

      var range = zoomMax - zoomMin;
      var adjustedRatio = (adjustedScale - zoomMin) / range;
      var valueRatio = Math.sqrt(adjustedRatio);
      var scale = valueRatio * range + zoomMin;

      return scale;
    },


    zoomIn: function zoomIn() {
      var deltaScale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var adjustedScale = this.scaleSquareRoot(this.currentScale);
      var newScale = this.scaleSquare(adjustedScale + deltaScale);

      // Prevent juddering scale at end of range by snapping to min/max
      // on large deltaScales
      var SNAP = 0.2;

      if (deltaScale > 0.1 && this.zoomMax - newScale < SNAP) {
        newScale = this.zoomMax;
      } else if (deltaScale < -0.1 && newScale - this.zoomMin < SNAP) {
        newScale = this.zoomMin;
      }

      return this.scale(newScale);
    },

    zoomOut: function zoomOut() {
      var deltaScale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return this.zoomIn(-deltaScale);
    },

    translate: function translate(dx, dy) {
      if (dx === this.dx && dy === this.dy) {
        return;
      }

      // TODO constrain
      this.dx = dx;
      this.dy = dy;

      return this.updateTransform();

      // return { dx: dx, dy: dy };


      // return translate(this.elem, {
      //   dx: dx,
      //   dy: dy,
      //   width: this.width,
      //   height: this.height,
      //   viewportWidth: this.viewportWidth,
      //   viewportHeight: this.viewportHeight,
      //   scale: this.currentScale,
      //   constrain: this.constrain
      // });
    },

    setViewportOriginRatio: function setViewportOriginRatio(xRatio, yRatio) {
      // if (debug) {
      //   console.log('setViewportOriginRatio', { xRatio, yRatio, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight }, xRatio * this.viewportWidth, yRatio * this.viewportHeight);
      // }

      return this.setViewportOrigin(xRatio * this.viewportWidth, yRatio * this.viewportHeight);
    },

    setViewportOrigin: function setViewportOrigin(viewportX, viewportY) {
      var xRatio = (viewportX - this.dx) / this.viewportWidth;
      var yRatio = (viewportY - this.dy) / this.viewportHeight;

      if (xRatio === this.viewportFocusXRatio && yRatio === this.viewportFocusXRatio) {
        return;
      }

      // Ratio of client position in parent's box
      this.viewportFocusXRatio = xRatio;
      this.viewportFocusYRatio = yRatio;

      return this.updateTransform();
    },

    setOriginViaViewportRatio: function setOriginViaViewportRatio(xRatio, yRatio, updateViewportOrigin) {
      return this.setOriginViaViewport(this.viewportWidth * xRatio, this.viewportHeight * yRatio, updateViewportOrigin);
    },

    setOriginViaViewport: function setOriginViaViewport(viewportX, viewportY, updateViewportOrigin) {
      var imageOriginX = viewportX / this.currentScale - this.offsetX + this.viewBox[0];
      var imageOriginY = viewportY / this.currentScale - this.offsetY + this.viewBox[1];

      // imageOriginX = this.width / 2 + this.viewBox[0];
      // imageOriginY = this.height / 2 + this.viewBox[1];

      if (updateViewportOrigin) {
        this.setViewportOrigin(viewportX, viewportY);
      }

      // console.log('setOriginViaViewport', {viewportX, viewportY, imageOriginX, imageOriginY, viewBox: this.viewBox, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight, offsetX: this.offsetX, offsetY: this.offsetY});

      return this.setImageOrigin(imageOriginX, imageOriginY);
    },

    setImageOrigin: function setImageOrigin(x, y) {
      if (typeof x === 'number' && !isNaN(x) && typeof y === 'number' && !isNaN(y)) {
        // const imageOriginX = x + this.viewBox[0];
        // const imageOriginY = y + this.viewBox[1];

        // if (imageOriginX === this.imageOriginX && imageOriginY === this.imageOriginY) {
        //   return;
        // }

        if (x === this.imageOriginX && y === this.imageOriginY) {
          return;
        }

        this.imageOriginX = x;
        this.imageOriginY = y;

        this.updateTransform();
      }
    },

    updateTransform: function updateTransform(isResize) {
      var _this = this;

      if (isResize) {
        this.captureDimensions();
      }

      this.offsetX = (this.viewportWidth * this.viewportFocusXRatio + this.dx) / this.currentScale - (this.imageOriginX - this.viewBox[0]);

      this.offsetY = (this.viewportHeight * this.viewportFocusYRatio + this.dy) / this.currentScale - (this.imageOriginY - this.viewBox[1]);

      // this.offsetX = Math.round((this.viewportWidth * this.viewportFocusXRatio + this.dx) / this.currentScale - this.imageOriginX);

      // this.offsetY = Math.round((this.viewportHeight * this.viewportFocusYRatio + this.dy) / this.currentScale - this.imageOriginY);

      if (this.waitingForAnimation) {
        return;
      }

      this.waitingForAnimation = true;

      // console.log('updateTransform', {
      //   dx: this.dx,
      //   dy: this.dy,
      //   viewportWidth: this.viewportWidth,
      //   viewportHeight: this.viewportHeight,
      //   viewportFocusXRatio: this.viewportFocusXRatio,
      //   viewportFocusYRatio: this.viewportFocusYRatio,
      //   imageOriginX: this.imageOriginX,
      //   imageOriginY: this.imageOriginY,
      //   currentScale: this.currentScale,
      //   offsetX: this.offsetX,
      //   offsetY: this.offsetY,
      //   isResize
      // });

      requestAnimationFrame(function () {
        var transform = '';

        // if (this.left || this.top) {
        //   transform += 'translate(' + -this.left + 'px,' + -this.top + 'px)';
        // }

        if (_this.currentScale) {
          // transform += 'scale(' + this.currentScale.toFixed(5) + ') ';
          var scale = _this.currentScale;
          var originX = _this.viewBox[0] - _this.currentScale * _this.viewBox[0];
          var originY = _this.viewBox[1] - _this.currentScale * _this.viewBox[1];

          transform += 'matrix(' + scale + ', 0, 0, ' + scale + ', ' + originX + ', ' + originY + ')';
        }

        if (_this.offsetX || _this.offsetY) {
          // transform += 'translate(' + this.offsetX + 'px,' + this.offsetY + 'px)';
          transform += 'translate(' + _this.offsetX + ',' + _this.offsetY + ')';
        }

        _this.elem.firstElementChild.setAttribute('transform', transform);

        // const minX = (- this.offsetX)  * this.currentScale;
        // const minY = (- this.offsetY)  * this.currentScale;
        // const width = this.viewportWidth / this.currentScale;
        // const height = this.viewportHeight / this.currentScale;

        // this.elem.setAttribute('viewBox', [minX, minY, width, height].join(' '));

        _this.waitingForAnimation = false;

        var hasScaleListeners = _this.on.scale.length;
        var hasOffsetListeners = _this.on.offset.length;

        var notifyScaleChange = !!_this.on.scale.length && _this.previousScale !== _this.currentScale;
        var notifyOffsetChange = !!_this.on.offset.length && (_this.previousOffsetX !== _this.offsetX || _this.previousOffsetY !== _this.offsetY);

        if (_this.on.scale.length) {
          if (_this.previousScale !== _this.currentScale) {
            _this.on.scale.forEach(_this._getScale);
          }

          _this.previousScale = _this.currentScale;
        }

        if (_this.on.offset.length) {
          if (_this.previousOffsetX !== _this.offsetX || _this.previousOffsetY !== _this.offsetY) {
            _this.on.offset.forEach(_this._getOffset);
          }

          _this.previousOffsetX = _this.offsetX;
          _this.previousOffsetY = _this.offsetY;
        }

        // const notifyResize = this.on.resize.length > 0 && isResize;

        if (_this.on.resize.length) {
          if (isResize) {
            _this.on.resize.forEach(_this._getZoomRange);
          }
        }
      });
    },

    _getScale: function _getScale(fn) {
      fn(this.currentScale);
    },

    _getOffset: function _getOffset(fn) {
      fn({
        dx: this.dx,
        dy: this.dy,
        offsetX: this.offsetX,
        offsetY: this.offsetY
      });
    },

    _getZoomRange: function _getZoomRange(fn) {
      fn({
        zoomMin: this.zoomMin,
        zoomMax: this.zoomMax
      });
    },

    onScaleChange: function onScaleChange(fn) {
      this.on.scale.push(fn);
    },

    onOffsetChange: function onOffsetChange(fn) {
      this.on.offset.push(fn);
    },

    onResize: function onResize(fn) {
      this.on.resize.push(fn);
    },

    onClick: function onClick(fn) {
      this.on.click.push(fn);
    },

    // fitToContainer: function () {
    //   if (this.defaultScale < 1) {
    //     this.scale(this.defaultScale);
    //     this.setOriginViaViewportRatio(0.5, 0.5, true);
    //   }
    // },

    center: function center(bboxOrElem) {
      var bbox = bboxOrElem instanceof SVGElement ? bboxOrElem.getBBox() : bboxOrElem;

      return this.setImageOrigin(bbox.x + bbox.width / 2, bbox.y + bbox.height / 2);
    },

    contain: function contain(bboxOrElem) {
      var _this2 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$scaleRatio = _ref.scaleRatio,
          scaleRatio = _ref$scaleRatio === undefined ? 1 : _ref$scaleRatio,
          _ref$animate = _ref.animate,
          animate = _ref$animate === undefined ? false : _ref$animate,
          _ref$inSeries = _ref.inSeries,
          inSeries = _ref$inSeries === undefined ? false : _ref$inSeries;

      var bbox = bboxOrElem instanceof SVGElement ? bboxOrElem.getBBox() : bboxOrElem;

      // TODO transition dx,dy => transfer to imageOriginX/Y
      // TODO use viewBox

      var xTo = bbox.x + bbox.width / 2;
      var yTo = bbox.y + bbox.height / 2;
      var scaleTo = Math.min(this.zoomMax, scaleRatio * this.viewportWidth / bbox.width, scaleRatio * this.viewportHeight / bbox.height);

      // console.log('contain', {animate, xTo, yTo, scaleRatio, scaleTo, zoomMax: this.zoomMax, bbox});

      if (!animate) {
        this.setImageOrigin(xTo, yTo);
        this.scale(scaleTo);
        // console.log(2,dimensions(this.elem.parentNode));
        return Promise.resolve();
      }

      var promise = Promise.resolve();

      if (xTo !== this.imageOriginX && yTo !== this.imageOriginY) {
        var deltaX = Math.abs(xTo - this.imageOriginX) * this.panTransitionIncrement;
        var deltaY = Math.abs(yTo - this.imageOriginY) * this.panTransitionIncrement;

        var animatePan = function animatePan() {
          return animateWhile(function () {
            var newX = void 0,
                newY = void 0;

            if (_this2.imageOriginX < xTo) {
              newX = _this2.imageOriginX + deltaX;

              if (newX > xTo) {
                newX = xTo;
              }
            } else {
              newX = _this2.imageOriginX - deltaX;

              if (newX < xTo) {
                newX = xTo;
              }
            }

            if (_this2.imageOriginY < yTo) {
              newY = _this2.imageOriginY + deltaY;

              if (newY > yTo) {
                newY = yTo;
              }
            } else {
              newY = _this2.imageOriginY - deltaY;

              if (newY < yTo) {
                newY = yTo;
              }
            }

            _this2.setImageOrigin(newX, newY);

            return newX !== xTo || newY !== yTo;
          });
        };

        promise = promise.then(animatePan());
      }

      if (scaleTo !== this.currentScale) {
        var deltaScale = Math.abs(scaleTo - this.currentScale) * this.zoomTransitionIncrement;

        var animateZoom = function animateZoom() {
          return animateWhile(function () {
            var newScale = void 0;

            if (_this2.currentScale < scaleTo) {
              newScale = _this2.currentScale + deltaScale;

              if (newScale > scaleTo) {
                newScale = scaleTo;
              }
            } else {
              newScale = _this2.currentScale - deltaScale;

              if (newScale < scaleTo) {
                newScale = scaleTo;
              }
            }

            _this2.scale(newScale);

            return newScale !== scaleTo;
          });
        };

        if (inSeries) {
          promise = promise.then(animateZoom());
        } else {
          promise = Promise.all([promise, animateZoom()]);
        }
      }

      return promise;
      // return promise.then(() => console.log(3,dimensions(this.elem.parentNode)));
    },

    getPadding: function getPadding() {
      var paddingLeft = this.paddingLeft,
          paddingRight = this.paddingRight,
          paddingTop = this.paddingTop,
          paddingBottom = this.paddingBottom;


      if (typeof paddingLeft === 'string' && paddingLeft.slice(-1) === '%') {
        paddingLeft = Math.round(parseInt(paddingLeft) * this.width / 100);
      }

      if (typeof paddingRight === 'string' && paddingRight.slice(-1) === '%') {
        paddingRight = Math.round(parseInt(paddingRight) * this.width / 100);
      }

      if (typeof paddingTop === 'string' && paddingTop.slice(-1) === '%') {
        paddingTop = Math.round(parseInt(paddingTop) * this.height / 100);
      }

      if (typeof paddingBottom === 'string' && paddingBottom.slice(-1) === '%') {
        paddingBottom = Math.round(parseInt(paddingBottom) * this.height / 100);
      }

      return { paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop, paddingBottom: paddingBottom };
    },

    resetView: function resetView(animate) {
      // TODO animate dx,dy
      if (this.dx || this.dy) {
        this.dx = 0;
        this.dy = 0;
      }

      this.captureDimensions();

      this.setOriginViaViewportRatio(0.5, 0.5, true);

      var _getPadding2 = this.getPadding(),
          paddingLeft = _getPadding2.paddingLeft,
          paddingRight = _getPadding2.paddingRight,
          paddingTop = _getPadding2.paddingTop,
          paddingBottom = _getPadding2.paddingBottom;

      // console.log('padding', { paddingLeft, paddingRight, paddingTop, paddingBottom });

      return this.contain({
        x: -paddingLeft + this.viewBox[0],
        y: -paddingTop + this.viewBox[1],
        width: this.width + paddingLeft + paddingRight,
        height: this.height + paddingTop + paddingBottom
      }, { animate: animate });
    },

    resize: function resize() {
      this.updateTransform(true);
    },

    initializeZoomControl: function initializeZoomControl() {
      var zoomControl = this.zoomControl;

      if (!zoomControl) {
        throw new Error('panzoom: No such zoom control ' + selectorOrElement);
      }

      var optionElems = zoomControl.querySelectorAll('option');
      var zoomValues = Array.prototype.slice.apply(optionElems).map(function (option) {
        return Number(option.value) / 100;
      });

      var instance = this;

      zoomControl.addEventListener('change', function (event) {
        instance.scale(zoomValues[zoomControl.selectedIndex]);
      });

      this.updateZoomControl = function () {
        var currentSelection = zoomControl.selectedIndex;
        var closestIndex = 0;

        for (var i = 1; i < zoomValues.length; i++) {
          if (Math.abs(this.currentScale - zoomValues[i]) < Math.abs(this.currentScale - zoomValues[closestIndex])) {
            closestIndex = i;
          }
        }

        if (currentSelection !== closestIndex) {
          zoomControl.selectedIndex = closestIndex;
        }
      };
    },

    initializeZoomInOut: function initializeZoomInOut() {
      var zoomInButton = this.zoomInButton;

      if (!zoomInButton) {
        throw new Error('panzoom: No such zoom in control');
      }

      var zoomOutButton = this.zoomOutButton;

      if (!zoomOutButton) {
        throw new Error('panzoom: No such zoom out control');
      }

      var instance = this;

      zoomInButton.addEventListener('click', function (event) {
        instance.scaleSquare(instance.currentScale + instance.zoomIncrement);
      });

      zoomOutButton.addEventListener('click', function (event) {
        instance.scaleSquare(instance.currentScale - instance.zoomIncrement);
      });
    },

    getWheelData: function getWheelData(event) {
      // Modified from https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0,
          sY = 0,
          // spinX, spinY
      pX = 0,
          pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in event) {
        sY = event.detail;
      }
      if ('wheelDelta' in event) {
        sY = -event.wheelDelta / 120;
      }
      if ('wheelDeltaY' in event) {
        sY = -event.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in event) {
        sX = -event.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in event) {
        pY = event.deltaY;
      }
      if ('deltaX' in event) {
        pX = event.deltaX;
      }

      if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode === 1) {
          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {
          // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = pX < 1 ? -1 : 1;
      }
      if (pY && !sY) {
        sY = pY < 1 ? -1 : 1;
      }

      return { spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY };
    },

    initializeScrollToZoom: function initializeScrollToZoom() {
      var _this3 = this;

      addWheelListener(this.zoomDelegate || this.elem, function (event) {
        event.preventDefault();

        var wheelData = _this3.getWheelData(event);
        var wheelAmount = _this3.zoomType === 'spin' ? wheelData.spinX + wheelData.spinY : wheelData.pixelX + wheelData.pixelY;

        _this3.setOriginViaViewport(event.clientX - _this3.zoomDelegate.offsetLeft, event.clientY - _this3.zoomDelegate.offsetTop, true);
        // this.setOriginViaViewport(event.pageX - window.scrollX, event.pageX - window.scrollY, true);


        // this.scale(this.currentScale + wheelAmount / this.zoomSpeed);
        _this3.zoomIn(-wheelAmount / _this3.zoomSpeed);
      });
    },

    initializeZoom: function initializeZoom() {
      if (this.zoomControl) {
        this.initializeZoomControl();
      }

      if (this.zoomInButton && this.zoomOutButton) {
        this.initializeZoomInOut();
      }

      if (this.autosize) {
        this.resetView();

        window.addEventListener('resize', this.resize);
      }

      this.initializeScrollToZoom();
    },

    pointerPosition: function pointerPosition(event) {
      var x = event.touches && event.touches[0].pageX || event.pageX;
      var y = event.touches && event.touches[0].pageY || event.pageY;

      return { x: x, y: y };
    },


    // Re-translate to benefit from pan restrictions on zoom
    panRefresh: function panRefresh() {
      return this.translate(this.dx, this.dy);

      // this.dx = translation.dx;
      // this.dy = translation.dy;
    },

    addPanListeners: function addPanListeners() {
      // var options = passiveEventsSupported ? { passive: false } : undefined;

      // this.panDelegate.addEventListener('pointermove', this.pan);
      this.panDelegate.addEventListener('mousemove', this.pan);
      this.panDelegate.addEventListener('touchmove', this.pan);
      // this.panDelegate.addEventListener('pointerup', this.panStop);
      this.panDelegate.addEventListener('mouseup', this.panStop);
      this.panDelegate.addEventListener('touchend', this.panStop);
      this.panDelegate.addEventListener('mouseleave', this.panWaitForReenter);
    },

    removePanListeners: function removePanListeners() {
      // this.panDelegate.removeEventListener('pointermove', this.pan);
      this.panDelegate.removeEventListener('mousemove', this.pan);
      this.panDelegate.removeEventListener('touchmove', this.pan);
      // this.panDelegate.removeEventListener('pointerup', this.panStop);
      this.panDelegate.removeEventListener('mouseup', this.panStop);
      this.panDelegate.removeEventListener('touchend', this.panStop);
      this.panDelegate.removeEventListener('mouseleave', this.panWaitForReenter);
      this.panDelegate.removeEventListener('mouseenter', this.panResume);
    },

    panStart: function panStart(event) {
      // console.log('panStart', Date.now(), event.type, !!event.touches);

      if (this.panStartX !== null || this.ctrlKeyToPan && !event.ctrlKey && !event.metaKey) {
        return;
      }

      var _pointerPosition = this.pointerPosition(event),
          x = _pointerPosition.x,
          y = _pointerPosition.y;

      // Don't start panning, if started within pan gutter


      if (this.panGutterLeft && x < this.panGutterLeft || this.panGutterRight && x > this.viewportWidth - this.panGutterRight) {
        return;
      }

      // console.log('* panStart *', event, event.target !== this.elem && event.target.nodeName !== 'svg' && event.target instanceof SVGElement);

      // Prevent pan trigger on small content
      if (this.omitSmallShapes && event.target !== this.elem && event.target.nodeName !== 'svg') {
        if (event.target instanceof SVGElement) {
          var size = dimensions(event.target);
          var diff = Math.min(Math.abs(this.width - size.width), Math.abs(this.height - size.height));

          if (diff > 50) {
            return;
          }
        }
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // pan
      this.panning = true;
      this.panStartTime = Date.now();
      this.panStopTime = null;
      this.panStartPageX = x;
      this.panStartPageY = y;

      this.panStartX = x - this.dx;
      this.panStartY = y - this.dy;
      this.elem.style.cursor = 'grabbing';

      // console.log('*** panStart ***', { x, dx: this.dx, panStartX: this.panStartX });

      // pinch & zoom
      var touches = event.touches;

      if (touches && touches.length === 2) {
        // console.log('touches', event);
        // this.scaling = true;

        // console.log('panStart', !!Math.hypot, touches);

        this.pinchZoom = Math.hypot(touches[0].pageX - touches[1].pageX, touches[0].pageY - touches[1].pageY);
      }

      this.addPanListeners();
    },

    panStop: function panStop(event) {
      // if (event) {
      //   event.preventDefault();
      // }

      // console.log('panStop', Date.now());
      this.panStopTime = Date.now();

      var panChanged = event && (Math.abs(this.panStartPageX - event.pageX) > 10 || Math.abs(this.panStartPageY - event.pageY) > 10);

      // pan change; prevent mouseOver/click
      if (panChanged) {
        event.preventDefault();
      }

      this.panning = false;
      this.panStartX = this.panStartY = this.pinchZoom = null;
      this.pinchDirection = [];
      this.scaling = false;
      this.elem.style.cursor = 'grab';

      this.removePanListeners();

      if (!panChanged && this.on.click.length) {
        this.on.click.forEach(function (fn) {
          return fn(event);
        });
      }
    },

    pan: function pan(event) {
      var PINCHZOOM_FACTOR = 62;

      event.preventDefault();

      var touches = event.touches;

      // console.log('pan');

      if (touches && touches.length === 2) {
        var x1 = touches[0].pageX;
        var y1 = touches[0].pageY;
        var x2 = touches[1].pageX;
        var y2 = touches[1].pageY;
        var diffX = x2 - x1;
        var diffY = y2 - y1;
        var centerX = Math.abs(x1 + diffX / 2);
        var centerY = Math.abs(y1 + diffY / 2);
        var distance = Math.hypot(diffX, diffY);

        var previousPinchZoom = this.pinchZoom;

        this.pinchZoom = distance;

        // console.log({previousPinchZoom});

        if (previousPinchZoom !== null) {
          var distanceDiff = distance - previousPinchZoom;
          var deltaScale = distanceDiff / PINCHZOOM_FACTOR;

          if (Math.abs(deltaScale) < 0.002) {
            // console.log({deltaScale});

            this.pinchZoom = previousPinchZoom;
            return;
          }

          // Counter glitchy Android pinch/zoom measurement with averages
          var isZoomingIn = distanceDiff > 0;
          var isDirectionChange = this.pinchDirection.length > 3 && this.pinchDirection[this.pinchDirection.length - 1] !== isZoomingIn;

          if (isDirectionChange) {
            var agreement = this.pinchDirection.reduce(function (result, measurement) {
              return result + (measurement === isZoomingIn ? 1 : 0);
            }, 0);

            // console.log('fix?', { deltaScale, isZoomingIn, isDirectionChange, agreement, len: this.pinchDirection.length});

            if (agreement < this.pinchDirection.length / 2) {
              // console.log('fix', deltaScale);
              deltaScale = -deltaScale;
            }
          }

          this.pinchDirection.push(isZoomingIn);

          if (this.pinchDirection.length > 5) {
            this.pinchDirection.shift();
          }

          // console.log('pan', {previousPinchZoom, distance, deltaScale, isZoomingIn, isDirectionChange}, centerX - this.zoomDelegate.offsetLeft, centerY - this.zoomDelegate.offsetTop);

          // console.log('pan, pinch', touches[0], {diffX, diffY, centerX, centerY});

          this.setOriginViaViewport(centerX - this.zoomDelegate.offsetLeft, centerY - this.zoomDelegate.offsetTop, true);

          this.zoomIn(deltaScale);
        }
      } else {
        var _pointerPosition2 = this.pointerPosition(event),
            x = _pointerPosition2.x,
            y = _pointerPosition2.y;

        this.translate(x - this.panStartX, y - this.panStartY);
      }

      // dx, dy may be constrained
      // this.dx = translation.dx;
      // this.dy = translation.dy;
    },

    panResume: function panResume(event) {
      event.preventDefault();

      if (event.buttons !== 1) {
        this.panStop();
      } else {
        var _pointerPosition3 = this.pointerPosition(event),
            x = _pointerPosition3.x,
            y = _pointerPosition3.y;

        this.panStartX = x - this.dx;
        this.panStartY = y - this.dy;
      }

      document.removeEventListener('mouseenter', this.panResume);
    },

    panWaitForReenter: function panWaitForReenter(event) {
      event.preventDefault();
      document.addEventListener('mouseenter', this.panResume);
    },

    initializePan: function initializePan() {
      this.panStartX = this.panStartY = null;

      var elem = this.panDelegate || this.elem;

      // var options = passiveEventsSupported ? { passive: false } : undefined;

      // elem.addEventListener('pointerdown', this.panStart);
      elem.addEventListener('mousedown', this.panStart);
      elem.addEventListener('touchstart', this.panStart);
    }
  };

  return function panzoom(selectorOrElement, options) {
    return new PanZoom(selectorOrElement, options);
  };
}).apply(undefined, typeof window === 'undefined' ? [] : [window, document]));
// CONCATENATED MODULE: ./lib/worldmap.js






var container = void 0,
    worldmap_svg = void 0,
    highlightedCountry = void 0,
    controller = void 0;

var svgPromise = fetch('/assets/world.svg').then(function (xml) {
  if (xml.length) {
    worldmap_svg = xml[0];
    // paths = svg.querySelectorAll('path');
    return init(worldmap_svg);
  }

  throw new Error('Cannot load map');
});

function onMapReady() {
  return svgPromise;
}

function setPathAttributes(attrName, newValues) {
  onMapReady().then(function () {
    var elemsToReset = worldmap_svg.querySelectorAll('[' + attrName + ']');

    for (var i = 0; i < elemsToReset.length; i++) {
      elemsToReset[i].removeAttribute(attrName);
    }

    Object.keys(newValues).forEach(function (countryId) {
      var countryElem = getCountryElem(countryId);

      if (countryElem) {
        countryElem.setAttribute(attrName, newValues[countryId]);
      } else {
        console.log('MISSING COUNTRY', countryId);
      }
    });
  });
}

function currentScale() {
  var squareRoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!controller) {
    return 1;
  }

  var scale = controller.currentScale;

  return scale && squareRoot ? controller.scaleSquareRoot(scale) : scale;
}

function fadeOut() {
  container.classList.remove('active');
}

function fadeIn() {
  container.classList.add('active');
}

function zoom() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.scale(controller.scaleSquare(scale));
}

function zoomIn() {
  var scaleDiff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.zoomIn(scaleDiff);
}

function zoomOut() {
  var scaleDiff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.zoomOut(scaleDiff);
}

function panLeft() {
  controller.translate(controller.dx - 10, controller.dy);
}

function panRight() {
  controller.translate(controller.dx + 10, controller.dy);
}

function panUp() {
  controller.translate(controller.dx, controller.dy - 10);
}

function panDown() {
  controller.translate(controller.dx, controller.dy + 10);
}

function onScaleChange(fn) {
  onMapReady().then(function (controller) {
    return controller.onScaleChange(fn);
  });
}

function onResize(fn) {
  onMapReady().then(function (controller) {
    return controller.onResize(fn);
  });
}

function resetMap() {
  // console.log('resetMap');

  if (controller) {
    controller.resetView();
  }
}

function repaint() {
  // console.log('repaint');
  controller.updateTransform(true);
}

var currentCountryId = null;

function getCountryElem(countryId) {
  return countryId && worldmap_svg.querySelector('[data-country=' + countryId.toUpperCase() + ']') || null;
}

function getCountryBBox(countryElem) {
  if (!countryElem) {
    return null;
  }

  return countryElem.getBBox();
}

function positionCountry() {
  // console.log('positionCountry', window.innerWidth, window.innerHeight);
  controller.captureDimensions();

  if (window.innerWidth <= 300) {
    // console.log('0.7', [window.innerWidth, window.innerHeight]);
    controller.setViewportOriginRatio(0.8, 0.5);
  }

  // if (window.innerWidth <= 450 || window.innerHeight <= 600) {
  else if (window.innerWidth <= 450) {
      // console.log('0.7', [window.innerWidth, window.innerHeight]);
      controller.setViewportOriginRatio(0.7, 0.5);
    } else {
      // console.log('0.62', [window.innerWidth, window.innerHeight]);
      controller.setViewportOriginRatio(0.62, 0.5);
    }
}

function selectCountry(id) {
  // TEMP
  if (!worldmap_svg) {
    setTimeout(function () {
      return selectCountry(id);
    }, 500);
    return;
  }

  if (!id) {
    return;
  }

  var updateCountry = id !== currentCountryId;
  var countryElem = getCountryElem(id);

  if (updateCountry) {
    if (currentCountryId) {
      deselectCountry();
    }

    currentCountryId = id;
    container.classList.add('country-selected');
    countryElem.classList.add('selected');
  }

  var countryBBox = getCountryBBox(countryElem);

  positionCountry();

  // console.log('selectCountry', { countryBBox });
  controller.contain(countryBBox, { scaleRatio: 0.38, animate: false });
}

// window.addEventListener('orientationchange', () => setTimeout(repaint);

function deselectCountry() {
  // if (!currentCountryId) {
  //   return;
  // }

  currentCountryId = null;

  if (container) {
    container.classList.remove('country-selected');

    if (worldmap_svg) {
      var countryElem = worldmap_svg.querySelector('.selected');

      if (countryElem) {
        countryElem.classList.remove('selected');
      }
    }
  }
}

function onMouseOver(event) {
  // console.log('mouseover', controller.panStartTime, controller.panStopTime, Date.now() - controller.panStopTime);

  if (event.target.nodeName !== 'path' || !event.target.getAttribute('data-value')) {
    return;
  }

  if (controller && controller.panStartTime && controller.panStopTime && controller.panStopTime - controller.panStartTime < 200 && Date.now() - controller.panStopTime < 100) {
    return;
  }

  var countryId = event.target.getAttribute('data-country');

  if (countryId) {
    highlightedCountry.appendChild(event.target.cloneNode());
    highlightedCountry.appendChild(event.target.cloneNode());
  }
}

function onMouseOut() {
  // if (event.target.nodeName === 'path') {
  // svg.setAttribute('data-country', '');

  // const countryBackground = svg.querySelector('#selected-background');

  // if (countryBackground) {
  //   svg.removeChild(countryBackground);
  // }

  while (highlightedCountry.firstChild) {
    highlightedCountry.removeChild(highlightedCountry.firstChild);
  }
  // }
}

function onClick(event) {
  // setTimeout(() => {
  // panning finished; prevents a pan that ends on a country selecting the
  // country

  var now = Date.now();

  // console.log('click', controller.panning, now - controller.panStartTime, now - controller.panStopTime);

  // if (controller.panning || (controller.panStartTime && (now - controller.panStartTime) < 200) || controller.panStopTime && (now - controller.panStopTime) < 100) {
  //   return;
  // }

  // console.log('click', controller.panStopTime, (Date.now() - controller.panStopTime));


  if (event.target.nodeName === 'path') {
    var countryId = event.target.getAttribute('data-country');

    if (countryId) {
      var _currentPath = currentPath(),
          year = _currentPath.year;

      setRoute(year, countryId.toLowerCase());
      selectCountry(countryId);
    }

    // else {
    // controller.setViewportOrigin(event.clientX - svg.clientLeft, event.clientY - svg.clientTop);
    // controller.zoomIn();
    // }
  }
  // }, 4);
}

function onDblClick(event) {
  // TODO: animate zoomIn

  // console.log('dblclick');

  controller.setOriginViaViewport(event.clientX - controller.zoomDelegate.offsetLeft, event.clientY - controller.zoomDelegate.offsetTop, true);
  // controller.setOriginViaViewport(event.screenX - window.scrollX, event.screenY - window.scrollY, true);
  controller.zoomIn(1);
}

function addListeners() {
  worldmap_svg.addEventListener('mouseover', onMouseOver);
  worldmap_svg.addEventListener('mouseout', onMouseOut);
  // svg.addEventListener('click', onClick);

  // svg.addEventListener('touchstart', onClick);
  worldmap_svg.addEventListener('dblclick', onDblClick);
}

function removeListeners() {
  worldmap_svg.removeEventListener('mouseover', onMouseOver);
  worldmap_svg.removeEventListener('mouseout', onMouseOut);
  // svg.removeEventListener('click', onClick);
  // svg.removeEventListener('touchstart', onClick);
  worldmap_svg.removeEventListener('dblclick', onDblClick);
}

// Fix address bar height and vh units on mobile
// let vh = window.innerHeight * 0.01;
// document.documentElement.style.setProperty('--vh', `${vh}px`);

// function setVh () {
//   const newVh = window.innerHeight * 0.01;

//   if (newVh !== vh) {
//     vh = newVh;
//     document.documentElement.style.setProperty('--vh', `${vh}px`);
//   }
// }

function init(svg) {
  container = document.getElementById('worldmap');

  if (container) {
    return;
  }

  container = document.createElement('div');
  container.id = 'worldmap';

  if (currentPath().countryId) {
    container.classList.add('country-selected');
  }

  document.body.insertBefore(container, document.body.firstChild);

  highlightedCountry = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  highlightedCountry.classList.add('highlighted-country');
  svg.firstElementChild.appendChild(highlightedCountry);

  addListeners();

  container.appendChild(svg);

  // if (window.innerHeight < document.body.offsetHeight) {
  // console.log('resize map height', window.innerHeight, document.body.offsetHeight);

  // container.style.height = 100px; //`${container.offsetHeight - (document.body.offsetHeight - window.innerHeight)}px`;
  // }

  controller = panzoom(svg, {
    autosize: true,
    paddingLeft: '16.2%',
    paddingRight: '16.2%',
    paddingTop: '16.2%',
    paddingBottom: '16.2%',
    zoomMin: 0.2,
    zoomMax: 10,
    zoomIncrement: 0.5,
    zoomSpeed: 250,
    panTransitionIncrement: 0.5,
    panGutterRight: 20,
    zoomTransitionIncrement: 0.1
  });

  controller.onClick(onClick);

  // const worldbitmap = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  // const { paddingLeft, paddingRight, paddingTop, paddingBottom } = controller.getPadding();

  // const bbox = svg.firstElementChild.getBBox();
  // console.log({bbox});

  // worldbitmap.setAttribute('class', 'worldbitmap');
  // worldbitmap.setAttribute('opacity', 0.3);
  // worldbitmap.setAttribute('x', bbox.x);
  // worldbitmap.setAttribute('y', bbox.y);
  // worldbitmap.setAttribute('width', bbox.width);
  // worldbitmap.setAttribute('height', bbox.height);
  // worldbitmap.setAttribute('href', '/assets/world.png');
  // svg.firstElementChild.appendChild(worldbitmap);

  var waitingForAnimation = false;

  window.addEventListener('resize', function () {
    if (waitingForAnimation) {
      return;
    }

    waitingForAnimation = true;

    requestAnimationFrame(function () {
      waitingForAnimation = false;

      // setVh();

      if (currentCountryId) {
        selectCountry(currentCountryId);
      } else {
        resetMap();
      }

      controller.updateTransform(true);

      // const width = window.innerWidth;
      // const height = window.innerHeight;

      // setTimeout(() => {
      //   if (width !== innerWidth || height !== innerHeight) {
      //     console.log('setting 2');
      //     setVh();

      //     if (currentCountryId) {
      //       positionCountry();
      //     }

      //     controller.updateTransform(true);
      //   }
      // }, 250);
    });
  });

  window.c = controller;

  return controller;
}
// CONCATENATED MODULE: ./components/Header.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { resetMap } from '../lib/worldmap';



var Header__ref = Object(preact_min["h"])(
  'div',
  { 'class': 'org' },
  Object(preact_min["h"])(
    'a',
    { 'class': 'logo u-url', href: 'https://www.anglia.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project', target: '_blank' },
    Object(preact_min["h"])('img', { 'class': 'u-logo p-name p-org', alt: 'Anglia Ruskin University', src: '/assets/aru-logo.svg' })
  ),
  Object(preact_min["h"])(
    'svg',
    { 'class': 'division' },
    Object(preact_min["h"])('line', { x1: '0', y1: '0', x2: '0', y2: '100%' })
  ),
  Object(preact_min["h"])(
    'a',
    { 'class': 'faculty p-organization-unit', href: 'https://www.anglia.ac.uk/global-sustainability-institute-gsi', target: '_blank' },
    'Global Sustainability Institute'
  )
);

var Header_Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Header.prototype.render = function render(props) {
    var _currentPath = currentPath(),
        countryId = _currentPath.countryId,
        year = _currentPath.year;

    var resetUrl = countryId ? '/' + (year || '') : '/';

    // reset map on home; reset year if no countryId and map already reset

    return Object(preact_min["h"])(
      'header',
      { 'class': 'h-card' },
      Header__ref,
      Object(preact_min["h"])(
        'h1',
        null,
        Object(preact_min["h"])(
          preact_router_es_Link,
          { 'class': 'project-name', href: resetUrl, onClick: !countryId && resetMap },
          'Chaos Map'
        )
      )
    );
  };

  return Header;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/WorldMap.js
function WorldMap__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WorldMap__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WorldMap__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var WorldMap_WorldMap = function (_Component) {
  WorldMap__inherits(WorldMap, _Component);

  function WorldMap() {
    WorldMap__classCallCheck(this, WorldMap);

    return WorldMap__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  // state = {
  //   countries: {},
  //   selectedCountry: null
  // }

  WorldMap.prototype.deaths = function deaths(countries, year) {
    return Object.keys(countries).reduce(function (result, countryId) {
      var total = countries[countryId].totalByYear[year];

      if (!total) {
        return result;
      }

      var deaths = total['num dead'] || 0;
      var suicides = total['num suicide'] || 0;
      var totalDeaths = deaths + suicides;

      if (totalDeaths) {
        result[countryId] = getValueGrouping(totalDeaths);
      }

      return result;
    }, {});
  };

  WorldMap.prototype.setYear = function setYear(year) {
    setPathAttributes('data-value', this.deaths(this.countries, year));
  };

  WorldMap.prototype.componentWillMount = function componentWillMount() {
    // getCountries()
    // .then(countries => this.setState({ countries }))
    // .then(onMapReady)
    // .then(fadeIn);

    var _props = this.props,
        countries = _props.countries,
        selectedCountry = _props.selectedCountry,
        year = _props.year;
    // console.log('componentWillMount', { selectedCountry, countries, year });

    if (countries) {
      this.countries = countries;

      // this.setState({ countries });
      onMapReady().then(fadeIn);

      // window.addEventListener('resize', () => {
      // console.log('WorldMap resize', selectedCountry);

      // // Ensure alignment on resize
      // if (selectedCountry) {
      //   selectCountry(selectedCountry);
      // }

      // else {
      //   resetMap();
      // }

      // });

      // window.addEventListener('orientationchange', () =>
      //   console.log('orientchange') || setTimeout(repaint, 250)
      // );

      // onResize(function () {
      //   console.log('resize');
      //   // Ensure alignment on resize
      //   if (selectedCountry) {
      //     selectCountry(selectedCountry);
      //   }
      // });
    }

    if (selectedCountry) {
      this.selectedCountry = selectedCountry;
      // this.setState({ selectedCountry });
      selectCountry(selectedCountry);
    }

    if (year) {
      this.year = year;
      this.setYear(year);
    }
  };

  WorldMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var countries = _ref.countries,
        selectedCountry = _ref.selectedCountry,
        year = _ref.year;

    // console.log('componentWillReceiveProps', { countries: !!countries, selectedCountry, year }, { countries: this.countries === countries, selectedCountry: this.selectedCountry === selectedCountry || this.selectedCountry, year: this.year === year || this.year });

    if (countries !== this.countries) {
      // this.setState({ countries });
      this.countries = countries;
    }

    if (selectedCountry !== this.selectedCountry) {
      if (selectedCountry) {
        selectCountry(selectedCountry);
      } else {
        if (this.selectedCountry) {
          deselectCountry();
          resetMap();
        }
      }

      // this.setState({ selectedCountry });
      this.selectedCountry = selectedCountry;
    }

    if (year !== this.year) {
      this.year = year;
      this.setYear(year);
    }
  };

  WorldMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // console.log('shouldComponentUpdate', { selectedCountry: this.state.selectedCountry, countries: Object.keys(this.state.countries).length }, this.state.year, nextState.year, this.props.year, nextProps.year, nextProps.year === this.props.year);

    // // TODO: Reduce re-render
    // if (nextState.selectedCountry) {
    //   selectCountry(nextState.selectedCountry);
    // }

    // else if (this.state.selectedCountry) {
    //   deselectCountry();
    //   resetMap();
    // }

    return false;

    // if (nextState.countries !== this.state.countries) {
    //   return true;
    // }

    // if (nextState.countries && nextState.selectedCountry !== this.state.selectedCountry) {
    //   return true;
    // }

    // return false;
  };

  WorldMap.prototype.render = function render() {
    var countries = this.countries,
        selectedCountry = this.selectedCountry;

    var country = selectedCountry && countries[selectedCountry];

    // console.log('WorldMap', { selectedCountry, country });

    // return <div id="worldmap">{ svg }</div>;
    // return this.props.children;
    return null;
  };

  return WorldMap;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Slider.js


function Slider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Slider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Slider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Slider__ref = Object(preact_min["h"])('rect', { width: '22', height: '22', fill: 'none' });

var Slider__ref2 = Object(preact_min["h"])('rect', { width: '22', height: '22', fill: 'none' });

var Slider__ref3 = Object(preact_min["h"])('rect', { x: '2', y: '2', 'class': 'thumb', width: '26', height: '28', fill: '#003366', 'stroke-width': '2', stroke: '#003366' });

var Slider__ref4 = Object(preact_min["h"])('path', { stroke: '#7997B3', 'stroke-width': '1', d: 'M12 10 v12 m2 -12 v12 m2 -12 v12 m2 -12 v12' });

var Slider_Slider = function (_Component) {
  Slider__inherits(Slider, _Component);

  function Slider() {
    var _temp, _this, _ret;

    Slider__classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Slider__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onInput = function () {
      if (_this.props.onInput) {
        _this.props.onInput(_this.value());
      }
    }, _this.onChange = function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.value());
      }
    }, _this.moveStart = function (event) {
      var screenX = event.screenX,
          touches = event.touches;


      event.preventDefault();

      // console.log('moveStart');

      if (screenX === undefined && touches && touches.length) {
        screenX = touches[0].screenX;
      }

      _this.moveStartX = screenX;
      _this.moveStartValue = Number(_this.input.value);
      window.addEventListener('mousemove', _this.move);
      window.addEventListener('mouseup', _this.moveEnd);
      window.addEventListener('touchmove', _this.move);
      window.addEventListener('touchend', _this.moveEnd);

      _this.input.focus();
    }, _this.moveEnd = function () {
      // console.log('moveEnd');

      _this.moveStartX = undefined;
      _this.moveStartValue = undefined;
      window.removeEventListener('mousemove', _this.move);
      window.removeEventListener('mouseup', _this.moveEnd);
      window.removeEventListener('touchmove', _this.move);
      window.removeEventListener('touchend', _this.moveEnd);

      _this.input.focus();
    }, _this.move = function (event) {
      var buttons = event.buttons,
          screenX = event.screenX,
          touches = event.touches;


      event.preventDefault();

      if (screenX === undefined && touches && touches.length) {
        screenX = touches[0].screenX;
        buttons = 1;
      }

      // console.log('move', buttons, screenX);

      if (buttons === 1 && _this.moveStartX !== undefined && _this.gradation) {
        var width = _this.gradation.width.baseVal.value;
        var _this$props = _this.props,
            min = _this$props.min,
            max = _this$props.max,
            _this$props$step = _this$props.step,
            step = _this$props$step === undefined ? 1 : _this$props$step;

        var numSteps = (max - min) / step;
        var stepWidth = width / (numSteps - 1);
        var stepChange = Math.round((screenX - _this.moveStartX) / stepWidth);

        if (stepChange) {
          var newValue = _this.moveStartValue + stepChange;

          if (newValue < min) {
            newValue = min;
          } else if (newValue > max) {
            newValue = max;
          }

          var currentValue = Number(_this.input.value);

          if (newValue !== currentValue) {
            _this.input.value = newValue;
            _this.moveOriginX = screenX;

            if (_this.props.onInput) {
              _this.onInput();
            } else if (_this.props.onChange) {
              _this.onChange();
            }
          }
        }
      }
    }, _temp), Slider__possibleConstructorReturn(_this, _ret);
  }

  Slider.prototype.defaultValue = function defaultValue() {
    var _props = this.props,
        defaultValue = _props.defaultValue,
        min = _props.min,
        max = _props.max;

    return defaultValue || (max - min) / 2 + min;
  };

  Slider.prototype.value = function value() {
    var inputValue = this.input && Number(this.input.value);

    if (!isNaN(inputValue)) {
      return inputValue;
    }

    if (!isNaN(this.props.value)) {
      return this.props.value;
    }

    return this.defaultValue();
  };

  Slider.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (this.props.value !== nextProps.value && this.input) {
      this.input.value = nextProps.value;
    }

    return this.props.defaultValue !== nextProps.defaultValue || this.props.min !== nextProps.min || this.props.max !== nextProps.max || this.props.visible !== nextProps.visible;
  };

  Slider.prototype.componentDidMount = function componentDidMount() {
    var autofocus = this.props.autofocus;


    if (autofocus) {
      this.input.focus();
    }
  };

  Slider.prototype.renderGradation = function renderGradation(value) {
    var _this2 = this;

    // TODO move defs to index, once min/max years known
    var _props2 = this.props,
        min = _props2.min,
        max = _props2.max,
        _props2$step = _props2.step,
        step = _props2$step === undefined ? 1 : _props2$step;

    var valueRatio = (value - min) / (max - min);

    // const numSteps = Math.floor((max - min) / step) + 1;
    var numSteps = (max - min) / step;
    var stepWidthPercent = 100 / (numSteps - 1);
    var valueSteps = valueRatio && 1 / (numSteps * valueRatio);
    var valueWidthPercentString = valueRatio * 100 + '%';

    var lines = [];

    // console.log('renderGradation', {numSteps, stepWidth, valueWidthPercent})

    // for (let i = 0; i < numLines; i++) {
    //   const x = stepWidth * i + '%';

    //   lines.push(
    //     <line x1={ x } y1="25%" x2={ x } y2="75%" stroke="#003366" stroke-width="1"/>
    //   );
    // }

    return Object(preact_min["h"])(
      'svg',
      { 'class': 'gradation', ref: function ref(gradation) {
          return _this2.gradation = gradation;
        } },
      Object(preact_min["h"])(
        'defs',
        null,
        Object(preact_min["h"])(
          'pattern',
          { id: 'Slider-gradation-step', width: valueSteps, height: '100%' },
          Object(preact_min["h"])('line', { x1: stepWidthPercent / 2, y1: '25%', x2: stepWidthPercent / 2, y2: '75%', stroke: '#003366', 'stroke-width': '1' })
        )
      ),
      Object(preact_min["h"])(
        'g',
        { 'class': 'gradation-fill' },
        Object(preact_min["h"])('rect', { width: valueWidthPercentString, height: '100%', fill: 'url(#Slider-gradation-step)' })
      )
    );
  };

  Slider.prototype.render = function render(props) {
    var _this3 = this;

    var min = props.min,
        max = props.max,
        _props$step = props.step,
        step = _props$step === undefined ? 1 : _props$step,
        onInput = props.onInput,
        onChange = props.onChange,
        _props$autofocus = props.autofocus,
        autofocus = _props$autofocus === undefined ? false : _props$autofocus,
        marker = props.marker,
        gradation = props.gradation,
        thumb = props.thumb,
        buttons = props.buttons,
        onIncrease = props.onIncrease,
        onDecrease = props.onDecrease,
        _props$visible = props.visible,
        visible = _props$visible === undefined ? true : _props$visible;


    if (!min || !max) {
      return null;
    }

    var className = 'Slider ' + (props.class || props.className || '');
    // const defaultValue = value || (max - min) / 2 + min;
    var value = this.value();
    var valueRatio = (value - min) / (max - min);
    var markerXPercent = marker && Math.round(valueRatio * 100);

    // console.log('slider render', { min, max, value });

    return Object(preact_min["h"])(
      'div',
      { 'class': className },
      gradation && this.renderGradation(value),
      marker && Object(preact_min["h"])(
        'span',
        { 'class': 'marker-container' },
        Object(preact_min["h"])(
          'span',
          {
            'class': 'marker',
            onTouchStart: this.moveStart,
            onMouseDown: this.moveStart,
            style: 'left: ' + markerXPercent + '%;' },
          value
        )
      ),
      buttons && Object(preact_min["h"])(
        'svg',
        { 'class': 'buttons' },
        Object(preact_min["h"])(
          'g',
          { 'class': 'button' },
          Slider__ref,
          Object(preact_min["h"])(
            'text',
            { x: '11', y: '16.5', onClick: onDecrease },
            '\uFF0D'
          )
        ),
        Object(preact_min["h"])(
          'g',
          { 'class': 'button' },
          Slider__ref2,
          Object(preact_min["h"])(
            'text',
            { x: '11', y: '16.5', onClick: onIncrease },
            '\uFF0B'
          )
        )
      ),
      Object(preact_min["h"])('input', {
        type: 'range',
        min: min,
        max: max,
        step: step,
        autofocus: autofocus,
        defaultValue: this.defaultValue(),
        onInput: onInput && this.onInput,
        onChange: onChange && this.onChange,
        ref: function ref(input) {
          return _this3.input = input;
        },
        tabIndex: visible ? 0 : -1
      }),
      thumb && Object(preact_min["h"])(
        'svg',
        { 'class': 'thumb-container',
          width: '30',
          height: '32',
          style: 'margin-left: calc(' + markerXPercent + '% - ' + (valueRatio * 30).toFixed(1) + 'px - ' + valueRatio.toFixed(1) + 'rem)',
          onTouchStart: this.moveStart,
          onMouseDown: this.moveStart
        },
        Slider__ref3,
        Slider__ref4
      )
    );
  };

  return Slider;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/PanControl.js


function PanControl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PanControl__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PanControl__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PanControl__ref = Object(preact_min["h"])('circle', { fill: 'white', r: '32', cx: '32', cy: '32' });

var PanControl__ref2 = Object(preact_min["h"])(
  'g',
  { 'class': 'pan-button', onClick: panDown, transform: 'rotate(45, 32, 32)' },
  Object(preact_min["h"])('path', { d: 'M2,31 a31,31 0 0 1 29,-29 v29 z', stroke: 'none' }),
  Object(preact_min["h"])('path', { d: 'M16,26 v-10 h10', fill: 'none', 'stroke-width': '2' })
);

var PanControl__ref3 = Object(preact_min["h"])(
  'g',
  { 'class': 'pan-button', onClick: panLeft, transform: 'rotate(135, 32, 32)' },
  Object(preact_min["h"])('path', { d: 'M2,31 a31,31 0 0 1 29,-29 v29 z', stroke: 'none' }),
  Object(preact_min["h"])('path', { d: 'M16,26 v-10 h10', fill: 'none', 'stroke-width': '2' })
);

var PanControl__ref4 = Object(preact_min["h"])(
  'g',
  { 'class': 'pan-button', onClick: panUp, transform: 'rotate(225, 32, 32)' },
  Object(preact_min["h"])('path', { d: 'M2,31 a31,31 0 0 1 29,-29 v29 z', stroke: 'none' }),
  Object(preact_min["h"])('path', { d: 'M16,26 v-10 h10', fill: 'none', 'stroke-width': '2' })
);

var _ref5 = Object(preact_min["h"])(
  'g',
  { 'class': 'pan-button', onClick: panRight, transform: 'rotate(315, 32, 32)' },
  Object(preact_min["h"])('path', { d: 'M2,31 a31,31 0 0 1 29,-29 v29 z', stroke: 'none' }),
  Object(preact_min["h"])('path', { d: 'M16,26 v-10 h10', fill: 'none', 'stroke-width': '2' })
);

var PanControl_PanControl = function (_Component) {
  PanControl__inherits(PanControl, _Component);

  function PanControl() {
    PanControl__classCallCheck(this, PanControl);

    return PanControl__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PanControl.prototype.onKeyDown = function onKeyDown(event) {
    var key = event.key;

    if (!key) {
      var keyCode = event.which || event.keyCode;

      switch (keyCode) {
        case 37:
          key = 'ArrowLeft';
          break;

        case 38:
          key = 'ArrowUp';
          break;

        case 39:
          key = 'ArrowRight';
          break;

        case 40:
          key = 'ArrowDown';
          break;
      }
    }

    switch (key) {
      case 'ArrowLeft':
        return panRight();

      case 'ArrowUp':
        return panDown();

      case 'ArrowRight':
        return panLeft();

      case 'ArrowDown':
        return panUp();
    }
  };

  PanControl.prototype.render = function render(props) {
    var visible = props.visible;


    return Object(preact_min["h"])(
      'svg',
      { 'class': 'pan' + (visible ? ' visible' : ''), tabindex: visible ? 0 : -1, onKeyDown: this.onKeyDown, width: '66', height: '66', viewBox: '-1 -1 66 66' },
      PanControl__ref,
      PanControl__ref2,
      PanControl__ref3,
      PanControl__ref4,
      _ref5
    );
  };

  return PanControl;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/MapLegend.js


function MapLegend__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MapLegend__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MapLegend__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MapLegend__ref = Object(preact_min["h"])(
  "div",
  { "class": "MapLegend" },
  Object(preact_min["h"])(
    "h3",
    { "class": "title" },
    "Deaths"
  ),
  Object(preact_min["h"])(
    "svg",
    { height: "7" },
    Object(preact_min["h"])("rect", { x: "0", y: "0", width: "16.67%", height: "100%", fill: "#ADB7C2" }),
    Object(preact_min["h"])("rect", { x: "16.67%", y: "0", width: "16.67%", height: "100%", fill: "#051966" }),
    Object(preact_min["h"])("rect", { x: "33.33%", y: "0", width: "16.67%", height: "100%", fill: "#45B5E5" }),
    Object(preact_min["h"])("rect", { x: "50%", y: "0", width: "16.67%", height: "100%", fill: "#F1B433" }),
    Object(preact_min["h"])("rect", { x: "66.67%", y: "0", width: "16.67%", height: "100%", fill: "#F28430" }),
    Object(preact_min["h"])("rect", { x: "83.33%", y: "0", width: "16.67%", height: "100%", fill: "#ED4630" })
  ),
  Object(preact_min["h"])(
    "ul",
    { "class": "labels" },
    Object(preact_min["h"])(
      "li",
      null,
      "0"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "1"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "2-3"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "4-20"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "21-50"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "51+"
    )
  )
);

var MapLegend = function (_Component) {
  MapLegend__inherits(MapLegend, _Component);

  function MapLegend() {
    MapLegend__classCallCheck(this, MapLegend);

    return MapLegend__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MapLegend.prototype.render = function render() {
    return MapLegend__ref;
  };

  return MapLegend;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./lib/options-config.js
var options_config = __webpack_require__("EvNc");
var options_config_default = /*#__PURE__*/__webpack_require__.n(options_config);

// CONCATENATED MODULE: ./components/MapControls.js


function MapControls__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MapControls__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MapControls__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import sliderGradationDataUri from '../images/slider-gradation.svg';

var ZOOM_STEP = 0.2;

var MapControls__ref3 = Object(preact_min["h"])(MapLegend, null);

var MapControls_MapControls = function (_Component) {
  MapControls__inherits(MapControls, _Component);

  function MapControls() {
    var _temp, _this, _ret;

    MapControls__classCallCheck(this, MapControls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MapControls__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.zoom = function (scale) {
      return zoom(scale);
    }, _this._setYearThrottled = function () {
      _this.throttlingYearChange = false;
      _this.props.onChangeYear(_this.throttledYear);
    }, _this.setYear = function (year) {
      if (_this.throttledYear === year) {
        return;
      }

      _this.throttledYear = year;

      if (!_this.throttlingYearChange) {
        _this.throttlingYearChange = true;
        requestAnimationFrame(_this._setYearThrottled);
      }
    }, _this.zoomIn = function () {
      var zoomMax = _this.state.zoomMax;

      var scale = currentScale(true);

      if (scale === zoomMax) {
        return;
      }

      if (zoomMax - scale - ZOOM_STEP < 0.1) {
        zoom(zoomMax);
      } else {
        zoomIn(ZOOM_STEP);
      }
    }, _this.zoomOut = function () {
      var zoomMin = _this.state.zoomMin;

      var scale = currentScale(true);

      if (scale === zoomMin) {
        return;
      }

      if (scale - zoomMin - ZOOM_STEP < 0.1) {
        zoom(zoomMin);
      } else {
        zoomOut(ZOOM_STEP);
      }
    }, _temp), MapControls__possibleConstructorReturn(_this, _ret);
  }
  // transformInputScale (scale) {
  //   const { zoomMin, zoomMax } = this.state;
  //   const range = zoomMax - zoomMin;
  //   const valueRatio = (scale - zoomMin) / range;
  //   // const adjustedRatio = 1 - ((1 - valueRatio) * (1 - valueRatio));
  //   const adjustedRatio = valueRatio * valueRatio;
  //   const adjustedScale = adjustedRatio * range + zoomMin;

  //   return adjustedScale;
  // }

  // untransformInputScale (adjustedScale) {
  //   const { zoomMin, zoomMax } = this.state;
  //   const range = zoomMax - zoomMin;
  //   const adjustedRatio = (adjustedScale - zoomMin) / range;
  //   // const valueRatio = 1 - Math.sqrt(1 - adjustedRatio);
  //   const valueRatio = Math.sqrt(adjustedRatio);
  //   const scale = valueRatio * range + zoomMin;

  //   return scale;
  // }

  // setYear = year => {
  //   this.props.onChangeYear(year);
  // }

  MapControls.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    onScaleChange(function (scale) {
      return _this2.setState({ scale: scale });
    });
    onResize(function (_ref) {
      var zoomMin = _ref.zoomMin,
          zoomMax = _ref.zoomMax;
      return _this2.setState({ zoomMin: zoomMin, zoomMax: zoomMax });
    });

    onMapReady().then(function (_ref2) {
      var zoomMin = _ref2.zoomMin,
          zoomMax = _ref2.zoomMax,
          currentScale = _ref2.currentScale;
      return _this2.setState({ zoomMin: zoomMin, zoomMax: zoomMax, scale: currentScale });
    });
  };

  MapControls.prototype.render = function render(props, state) {
    var showPan = props.showPan,
        showZoom = props.showZoom,
        showYear = props.showYear,
        showIconsLegend = props.showIconsLegend,
        minYear = props.minYear,
        maxYear = props.maxYear;
    var scale = state.scale,
        zoomMin = state.zoomMin,
        zoomMax = state.zoomMax;

    var year = props.year || maxYear;
    var yearSliderRatio = (year - minYear) / (maxYear - minYear);
    var adjustedScale = currentScale(true);

    return Object(preact_min["h"])(
      'div',
      { 'class': 'MapControls' },
      Object(preact_min["h"])(PanControl_PanControl, { visible: showPan }),
      Object(preact_min["h"])(
        'div',
        { 'class': 'zoom ' + (showZoom ? 'visible' : '') },
        Object(preact_min["h"])(Slider_Slider, { min: zoomMin, max: zoomMax, step: ZOOM_STEP, defaultValue: zoomMin, value: adjustedScale, onInput: this.zoom, buttons: true, onIncrease: this.zoomIn, onDecrease: this.zoomOut, visible: showZoom })
      ),
      MapControls__ref3,
      Object(preact_min["h"])(
        'div',
        { 'class': 'year ' + (showYear ? 'visible' : '') },
        Object(preact_min["h"])(
          'style',
          { id: 'year-fill' },
          '.MapControls .year .Slider:before {\n            background-image: linear-gradient(to right, #BCCCD8 calc((' + yearSliderRatio + ' * (100% - 3rem)) + 1.5rem), transparent 0);\n          }'
        ),
        Object(preact_min["h"])(Slider_Slider, { min: minYear, max: maxYear, value: year, defaultValue: year, onInput: this.setYear, onChange: this.setYear, autofocus: true, marker: true, gradation: true, thumb: true, visible: showYear })
      )
    );
  };

  return MapControls;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Wheel.js


function Wheel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Wheel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Wheel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Wheel__ref3 = Object(preact_min["h"])(
  "g",
  { "class": "target" },
  Object(preact_min["h"])("circle", { "class": "target-outer", r: "3.5%", cx: "156", cy: "50", fill: "none", stroke: "white", "stroke-width": "1%" }),
  Object(preact_min["h"])("circle", { "class": "target-inner", r: "1.75%", cx: "156", cy: "50", fill: "white" }),
  Object(preact_min["h"])("path", { "class": "pointer", d: "M70,5 v90 l86,-45z", fill: "rgba(127,127,127,0.4)" })
);

var Wheel_Wheel = function (_Component) {
  Wheel__inherits(Wheel, _Component);

  function Wheel() {
    var _temp, _this, _ret;

    Wheel__classCallCheck(this, Wheel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Wheel__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _temp), Wheel__possibleConstructorReturn(_this, _ret);
  }

  Wheel.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        fadeIn = _props.fadeIn,
        visible = _props.visible;


    if (fadeIn && visible) {
      setTimeout(function () {
        return _this2.setState({ visible: true });
      }, fadeIn);
    } else {
      this.setState({ visible: visible });
    }
  };

  Wheel.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var visible = _ref.visible;

    if (visible !== this.state.visible) {
      this.setState({ visible: visible });
    }
  };

  Wheel.prototype.rotatePoint = function rotatePoint() {
    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return [Math.round(Math.sin(angle) * radius + offset), Math.round(Math.cos(angle) * radius + offset)];
  };

  Wheel.prototype.renderWedges = function renderWedges(radius, segments) {
    var n = segments.length;
    var angle = Math.PI * 2 / n;
    var imageWidth = Math.round(radius * 0.38);
    var imageHeight = imageWidth;
    var pieCoords = [];
    var imageCoords = [];

    if (n === 1) {
      pieCoords.push([radius, radius]);
      imageCoords.push([radius, radius]);
    } else {
      for (var i = 0; i < n; i++) {
        pieCoords.push(this.rotatePoint(radius, angle * i - angle / 2, radius));
        imageCoords.push(this.rotatePoint(radius * 0.58, angle * i, radius));
      }
    }

    return [].concat(pieCoords.map(function (_ref2, i) {
      var x1 = _ref2[0],
          y1 = _ref2[1];

      var background = void 0;

      if (n === 1) {
        background = Object(preact_min["h"])("circle", { "class": "background", r: radius, cx: x1, cy: y1, fill: "#04B6E6" });
      } else {
        // Fnd next point; if this is the last coord, use first point
        var _pieCoords = pieCoords[i + 1 === n ? 0 : i + 1],
            x2 = _pieCoords[0],
            y2 = _pieCoords[1];


        background = Object(preact_min["h"])("path", { "class": "background", d: "M" + radius + "," + radius + " L" + x1 + "," + y1 + " A50,50 0 0 0 " + x2 + "," + y2 });
      }

      var _imageCoords$i = imageCoords[i],
          imageX = _imageCoords$i[0],
          imageY = _imageCoords$i[1];
      var _segments$i = segments[i],
          key = _segments$i.key,
          char = _segments$i.char,
          valueGroup = _segments$i.valueGroup;


      return Object(preact_min["h"])(
        "g",
        { "class": "wedge", key: key, "data-key": key, "data-value": valueGroup },
        background,
        Object(preact_min["h"])(
          "text",
          { "class": "icon", "font-size": imageWidth, "text-anchor": "middle", x: imageX, y: imageY + imageHeight / 2 },
          char
        )
      );
    }), [Object(preact_min["h"])("path", { "class": "lines", stroke: "white", "stroke-width": "0.5", fill: "none", d: pieCoords.map(function (coords) {
        return "M" + radius + "," + radius + " L" + coords.join(',');
      }).join(' ') })]);
  };

  Wheel.prototype.render = function render(props, state) {
    var visible = state.visible;
    var radius = props.radius,
        segments = props.segments;


    if (!segments.length) {
      return null;
    }

    return Object(preact_min["h"])(
      "svg",
      { "class": "Wheel" + (visible ? ' visible' : ''), viewBox: "0 0 162 100" },
      Wheel__ref3,
      this.renderWedges(radius, segments)
    );
  };

  return Wheel;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Options.js


function Options__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Options__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Options__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Options_Options = function (_Component) {
  Options__inherits(Options, _Component);

  function Options() {
    var _temp, _this, _ret;

    Options__classCallCheck(this, Options);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Options__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      disabled: false
    }, _this.onInput = function (event) {
      if (_this.props.onInput) {
        var _event$target = event.target,
            name = _event$target.name,
            checked = _event$target.checked;

        // console.log(name, checked);

        _this.props.onInput({ name: name, checked: checked });
      }
    }, _this.onSelect = function () {
      _this.setState({ disabled: true });

      if (_this.props.onSelect) {
        _this.props.onSelect(_this.props.name);
      }
    }, _this.onKeyDown = function (event) {
      var key = event.key;

      if (!key) {
        var keyCode = event.which || event.keyCode;

        switch (keyCode) {
          case 13:
            key = 'Enter';
            break;

          case 32:
            key = ' ';
            break;
        }
      }

      if (key === 'Enter' || key === ' ') {
        _this.onSelect();

        if (document.activeElement) {
          // document.activeElement.blur();

          _this.firstCheckbox.focus();

          // const legends = document.querySelectorAll('.Options legend');

          // for (let i = 0; i < legends.length; i++) {
          //   if (legends[i] !== this.legend) {
          //     legends[i].parentNode.querySelector('li input').focus();
          //     break;
          //   }
          // }
        }
      }
    }, _temp), Options__possibleConstructorReturn(_this, _ret);
  }

  Options.prototype.componentWillMount = function componentWillMount() {
    if (this.props.disabled) {
      this.setState({ disabled: true });
    }
  };

  Options.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (props.disabled !== this.state.disabled) {
      this.setState({ disabled: props.disabled });
    }
  };

  // componentDidMount () {
  //   if (this.props.disabled) {
  //     this.legend.focus();
  //   }
  // }

  Options.prototype.render = function render(props, state) {
    var _this2 = this;

    var title = props.title,
        items = props.items,
        _props$tabIndex = props.tabIndex,
        tabIndex = _props$tabIndex === undefined ? false : _props$tabIndex;
    var disabled = state.disabled;


    return Object(preact_min["h"])(
      'fieldset',
      { 'class': 'Options' + (disabled ? ' disabled' : ''), onClick: disabled && this.onSelect },
      Object(preact_min["h"])(
        'legend',
        { tabIndex: disabled ? 0 : -1, onKeyDown: disabled && this.onKeyDown, ref: function ref(legend) {
            return _this2.legend = legend;
          } },
        title
      ),
      Object(preact_min["h"])(
        'ul',
        null,
        items.map(function (item, i) {
          var label = void 0;

          if (item.labelShort && window.innerWidth <= 450) {
            label = item.labelShort;
          } else {
            label = item.label || '' + item.key[0].toUpperCase() + item.key.slice(1);
          }

          return Object(preact_min["h"])(
            'li',
            null,
            Object(preact_min["h"])('input', { type: 'checkbox', id: 'checkbox-' + item.key, name: item.key, defaultChecked: item.checked !== false, onChange: _this2.onInput, tabIndex: disabled ? -1 : tabIndex, ref: function ref(checkbox) {
                if (i === 0) {
                  _this2.firstCheckbox = checkbox;
                }
              } }),
            Object(preact_min["h"])(
              'label',
              { htmlFor: 'checkbox-' + item.key },
              Object(preact_min["h"])(
                'span',
                { 'class': 'icon' },
                item.char
              ),
              ' ',
              Object(preact_min["h"])(
                'span',
                { 'class': 'title' },
                label
              )
            )
          );
        })
      )
    );
  };

  return Options;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/StatsBox.js


function StatsBox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StatsBox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StatsBox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var StatsBox_StatsBox = function (_Component) {
  StatsBox__inherits(StatsBox, _Component);

  function StatsBox() {
    var _temp, _this, _ret;

    StatsBox__classCallCheck(this, StatsBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = StatsBox__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _temp), StatsBox__possibleConstructorReturn(_this, _ret);
  }

  StatsBox.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        fadeIn = _props.fadeIn,
        visible = _props.visible;


    if (fadeIn && visible) {
      setTimeout(function () {
        return _this2.setState({ visible: true });
      }, fadeIn);
    } else {
      this.setState({ visible: visible });
    }
  };

  StatsBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var visible = _ref.visible;

    if (visible !== this.state.visible) {
      this.setState({ visible: visible });
    }
  };

  StatsBox.prototype.itemSummaryText = function itemSummaryText(_ref2) {
    var key = _ref2.key,
        label = _ref2.label,
        deaths = _ref2.deaths,
        suicides = _ref2.suicides;

    // const type = label || `${key[0].toUpperCase()}${key.slice(1)}`;
    // let desc = deaths ? `${deaths} death${deaths === 1 ? '' : 's'}` : '';

    // if (suicides) {
    //   desc += `${deaths ? ' + ' : ''}${suicides} suicide${suicides === 1 ? '' : 's'}`;
    // }

    // const desc = `${suicides ? 'suicide' : 'death'}${value === 1 ? '' : 's'}`;
    // const typeLabel = isSuicide ? '' : ` — ${type}`;

    return Object(preact_min["h"])(
      'span',
      { 'class': 'total' },
      deaths ? Object(preact_min["h"])(
        'span',
        null,
        deaths + ' death' + (deaths === 1 ? '' : 's')
      ) : null,
      suicides ? Object(preact_min["h"])(
        'span',
        null,
        '' + (deaths ? ' + ' : '') + suicides + ' suicide' + (suicides === 1 ? '' : 's')
      ) : null
    );
  };

  StatsBox.prototype.render = function render(_ref3, _ref4) {
    var _this3 = this;

    var year = _ref3.year,
        totalDeaths = _ref3.totalDeaths,
        totals = _ref3.totals,
        children = _ref3.children;
    var visible = _ref4.visible;

    // console.log('StatsBox', { visible, year, totalDeaths, totals });

    return Object(preact_min["h"])(
      'section',
      { 'class': 'StatsBox' + (visible ? ' visible' : '') },
      totalDeaths > 0 && Object(preact_min["h"])(
        'h3',
        null,
        totalDeaths + ' death' + (totalDeaths === 1 ? '' : 's') + ' in ' + year
      ),
      totalDeaths > 0 && Object(preact_min["h"])(
        'ul',
        { 'class': 'totals' },
        totals.filter(function (_ref5) {
          var checked = _ref5.checked;
          return checked !== false;
        }).map(function (_ref6) {
          var key = _ref6.key,
              char = _ref6.char,
              label = _ref6.label,
              value = _ref6.value,
              deaths = _ref6.deaths,
              suicides = _ref6.suicides;
          return value > 0 && Object(preact_min["h"])(
            'li',
            { key: key, title: label },
            char.split('').map(function (char) {
              return Object(preact_min["h"])(
                'span',
                { 'class': 'icon' },
                char
              );
            }),
            _this3.itemSummaryText({ key: key, label: label, deaths: deaths, suicides: suicides })
          );
        })
      ),
      children
    );
  };

  return StatsBox;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Commentary.js


function Commentary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Commentary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Commentary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Commentary__ref5 = Object(preact_min["h"])(
  'footer',
  null,
  Object(preact_min["h"])(
    'p',
    { 'class': 'socialmedia' },
    'Follow us on ',
    Object(preact_min["h"])(
      'a',
      { href: 'https://twitter.com/angliaruskin', target: '_blank' },
      Object(preact_min["h"])('span', { 'class': 'icon-twitter' })
    ),
    ' ',
    Object(preact_min["h"])(
      'a',
      { href: 'https://www.facebook.com/angliaruskin', target: '_blank' },
      Object(preact_min["h"])('span', { 'class': 'icon-facebook' })
    )
  )
);

var Commentary_Commentary = function (_Component) {
  Commentary__inherits(Commentary, _Component);

  function Commentary() {
    var _temp, _this, _ret;

    Commentary__classCallCheck(this, Commentary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Commentary__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      visible: true
    }, _temp), Commentary__possibleConstructorReturn(_this, _ret);
  }

  Commentary.prototype.updateVisibility = function updateVisibility(_ref) {
    var _ref$items = _ref.items,
        items = _ref$items === undefined ? [] : _ref$items;

    var visible = items.length > 0;

    if (visible !== this.state.visible) {
      this.setState({ visible: visible });
    }
  };

  Commentary.prototype.componentWillMount = function componentWillMount() {
    this.updateVisibility(this.props);
  };

  Commentary.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.updateVisibility(props);
  };

  Commentary.prototype.render = function render(_ref2, _ref3) {
    var _ref2$items = _ref2.items,
        items = _ref2$items === undefined ? [] : _ref2$items;
    var visible = _ref3.visible;

    return Object(preact_min["h"])(
      'section',
      { id: 'commentary', 'class': 'Commentary' + (visible ? ' visible' : '') },
      Object(preact_min["h"])(
        'div',
        { 'class': 'container' },
        items.length > 0 && items.map(function (_ref4) {
          var _ref4$title = _ref4.title,
              title = _ref4$title === undefined ? '' : _ref4$title,
              _ref4$summary = _ref4.summary,
              summary = _ref4$summary === undefined ? '' : _ref4$summary,
              _ref4$url = _ref4.url,
              url = _ref4$url === undefined ? false : _ref4$url,
              region = _ref4.region,
              city = _ref4.city,
              village = _ref4.village;

          var location = [region, city, village].filter(function (place) {
            return !!place;
          }).join(', ');

          return Object(preact_min["h"])(
            'article',
            null,
            Object(preact_min["h"])(
              'header',
              null,
              location && Object(preact_min["h"])(
                'h3',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: url, target: '_blank' },
                  location
                )
              ),
              Object(preact_min["h"])(
                'h4',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: url, target: '_blank' },
                  title
                )
              )
            ),
            summary.split('\n').map(function (line) {
              return Object(preact_min["h"])(
                'p',
                null,
                line
              );
            })
          );
        })
      ),
      items.length > 0 && Commentary__ref5
    );
  };

  return Commentary;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Country.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Country__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Country__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Country__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ALL_TYPES = [].concat(options_config["RESOURCES"], options_config["UNREST"]);
var UNREST_SUICIDE = options_config["UNREST"].find(function (_ref) {
  var key = _ref.key;
  return key === 'suicide';
});

var _ref8 = Object(preact_min["h"])(
  'a',
  { 'class': 'commentary-link', href: '#commentary' },
  Object(preact_min["h"])('span', { 'class': 'icon-commentary' }),
  ' ',
  Object(preact_min["h"])(
    'span',
    { 'class': 'label' },
    'Commentary'
  )
);

var Country_Country = function (_Component) {
  Country__inherits(Country, _Component);

  function Country() {
    var _temp, _this, _ret;

    Country__classCallCheck(this, Country);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Country__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selectedOptions: 'resource',
      wheelItems: options_config["UNREST"]
    }, _this.onOptionChange = function (_ref2) {
      var name = _ref2.name,
          checked = _ref2.checked;

      // console.log('onOptionChange', { name, checked });

      // this.setState({
      //   `option-${name}`: checked
      // });

      var collection = _this.state.selectedOptions === 'resource' ? options_config["RESOURCES"] : options_config["UNREST"];
      var item = collection.find(function (_ref3) {
        var key = _ref3.key;
        return key === name;
      });

      item.checked = checked;

      var wheelItems = _this.configureWedges(_this.props.country, _this.props.year);

      // console.log('onOptionChange', {wheelItems});
      _this.setState({ wheelItems: wheelItems });
    }, _this.onSelect = function (collectionName) {
      if (_this.state.selectedOptions !== collectionName) {
        _this.setState({ selectedOptions: collectionName });

        var wheelItems = _this.configureWedges(_this.props.country, _this.props.year);

        // console.log('onSelect', {wheelItems});
        _this.setState({ wheelItems: wheelItems });
      }
    }, _temp), Country__possibleConstructorReturn(_this, _ret);
  }

  Country.prototype.getOptions = function getOptions() {
    return this.state.selectedOptions === 'unrest' ? options_config["UNREST"] : options_config["RESOURCES"];
  };

  Country.prototype.getCheckedOptions = function getCheckedOptions() {
    return this.getOptions().filter(function (_ref4) {
      var _ref4$checked = _ref4.checked,
          checked = _ref4$checked === undefined ? true : _ref4$checked;
      return checked;
    });
  };

  Country.prototype.getCheckedOptionNames = function getCheckedOptionNames() {
    return this.getCheckedOptions().map(function (_ref5) {
      var key = _ref5.key;
      return key;
    });
  };

  Country.prototype.getTotalDeaths = function getTotalDeaths(eventsByYear) {
    if (!eventsByYear || !eventsByYear.length) {
      return 0;
    }

    var checkedOptions = this.getCheckedOptionNames();

    // don't count suicides if option is displayed and unchecked
    var includeSuicides = this.getOptions() !== options_config["UNREST"] || checkedOptions.includes('suicide');

    return eventsByYear.reduce(function (total, event) {
      // event type option is checked
      if (checkedOptions.some(function (option) {
        return event['is ' + option];
      }) || includeSuicides && event['num suicide']) {
        var deaths = event['num dead'] || 0;
        var suicides = includeSuicides && event['num suicide'] || 0;

        return total + deaths + suicides;
      }

      return total;
    }, 0);
  };

  Country.prototype.getEventKeys = function getEventKeys(event) {
    var includeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return Object.keys(event).filter(function (key) {
      return key.startsWith('is ') && (!includeList.length || includeList.includes(key));
    }).map(function (key) {
      return key.slice(3);
    }).sort();
  };

  Country.prototype._createGroupedItem = function _createGroupedItem(eventKeys) {
    var chars = [];
    var labels = [];

    eventKeys.forEach(function (key) {
      var _ALL_TYPES$find = ALL_TYPES.find(function (item) {
        return item.key === key;
      }),
          char = _ALL_TYPES$find.char,
          label = _ALL_TYPES$find.label;

      chars.push(char);
      labels.push(label || key[0].toUpperCase() + key.slice(1));
    });

    // console.log('group', { eventKeys, chars, labels })

    return {
      key: eventKeys.join('-'),
      char: chars.join(''),
      label: labels.join(' / '),
      value: 0,
      deaths: 0,
      suicides: 0
    };
  };

  Country.prototype.getValuesGrouped = function getValuesGrouped(collection, eventsByYear) {
    var _this2 = this;

    if (!eventsByYear || !eventsByYear.length) {
      return [];
    }

    var checkedOptions = this.getCheckedOptionNames();

    // don't count suicides if option is displayed and unchecked
    var includeSuicides = this.getOptions() !== options_config["UNREST"] || checkedOptions.includes('suicide');

    var collectionKeys = collection.map(function (_ref6) {
      var key = _ref6.key;
      return 'is ' + key;
    });

    var total = eventsByYear.reduce(function (total, event) {
      var deaths = event['num dead'] || 0;
      var suicides = includeSuicides && event['num suicide'] || 0;

      if (!deaths && !suicides) {
        return total;
      }

      var eventKeys = _this2.getEventKeys(event, collectionKeys).filter(function (key) {
        return checkedOptions.includes(key);
      });

      if (!eventKeys.length) {
        if (suicides) {
          eventKeys.push('suicide');
        } else {
          return total;
        }
      }

      var key = eventKeys.join('-');
      var item = total.find(function (item) {
        return item.key === key;
      });

      if (!item) {
        item = _this2._createGroupedItem(eventKeys);
        total.push(item);
      }

      item.deaths += deaths;
      item.suicides += suicides;
      item.value += deaths + suicides;

      return total;
    }, []);

    return total.sort(function (a, b) {
      return b.value - a.value;
    });
  };

  Country.prototype.getValuesByCollection = function getValuesByCollection(collection, eventsByYear) {
    if (!eventsByYear || !eventsByYear.length) {
      return [];
    }

    var checkedOptions = this.getCheckedOptionNames();

    // don't count suicides if option is displayed and unchecked
    var includeSuicides = this.getOptions() !== options_config["UNREST"] || checkedOptions.includes('suicide');

    var values = collection.map(function (item) {
      return _extends({}, item, {
        value: 0
      });
    });

    var suicideItem = values.find(function (item) {
      return item.key === 'suicide';
    });

    eventsByYear.forEach(function (event) {
      var deaths = event['num dead'];
      var suicides = event['num suicide'];

      Object.keys(event).filter(function (prop) {
        return prop.startsWith('is ') && event[prop] === true;
      }).forEach(function (prop) {
        var key = prop.slice(3);
        var item = values.find(function (item) {
          return item.key === key;
        });

        if (item) {
          if (deaths && item.key !== 'suicide') {
            item.value += deaths;
          }

          if (suicides && (item.key === 'suicide' || includeSuicides)) {
            item.value += suicides;
          }
        }
      });

      if (suicideItem && suicides) {
        suicideItem.value += suicides;
      }
    });

    return values.map(function (item) {
      return _extends({}, item, {
        valueGroup: getValueGrouping(item.value)
      });
    });
  };

  Country.prototype.configureWedges = function configureWedges(country, year) {
    var wedgeCollection = this.state.selectedOptions === 'unrest' ? options_config["RESOURCES"] : options_config["UNREST"];
    var eventsByYear = country.eventsByYear[year];

    if (!eventsByYear) {
      return wedgeCollection;
    }

    return this.getValuesByCollection(wedgeCollection, eventsByYear);
  };

  Country.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        country = _props.country,
        year = _props.year;


    if (country && year) {
      var wheelItems = this.configureWedges(country, year);

      // console.log('Country componentWillMount', {wheelItems});
      this.setState({ wheelItems: wheelItems });
    }
  };

  Country.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref7) {
    var country = _ref7.country,
        year = _ref7.year;

    if (country && year) {
      var wheelItems = this.configureWedges(country, year);

      // console.log('Country componentWillReceiveProps', {wheelItems});
      this.setState({ wheelItems: wheelItems });
    }
  };

  Country.prototype.render = function render(props, state) {
    var country = props.country,
        year = props.year;
    var selectedOptions = state.selectedOptions,
        wheelItems = state.wheelItems;


    if (!country) {
      return null;
    }

    var eventsByYear = country.eventsByYear[year];
    var totalDeaths = this.getTotalDeaths(eventsByYear);
    var summaryTotals = this.getValuesGrouped(this.getOptions(), eventsByYear);
    var commentaries = eventsByYear && eventsByYear.map(function (event) {
      return event.commentary;
    }).filter(function (commentary) {
      return !!commentary;
    });

    // console.log('Country', country.name, selectedOptions, eventsByYear);

    return Object(preact_min["h"])(
      'div',
      { 'class': 'Country' },
      Object(preact_min["h"])(
        'h2',
        null,
        country.name
      ),
      Object(preact_min["h"])(Wheel_Wheel, { radius: 50, segments: wheelItems, visible: !!totalDeaths, fadeIn: 620 }),
      Object(preact_min["h"])(
        'div',
        { 'class': 'country-options' },
        Object(preact_min["h"])(Options_Options, { name: 'resource', title: 'Resource', items: options_config["RESOURCES"], disabled: selectedOptions !== 'resource', onSelect: this.onSelect, onInput: this.onOptionChange, tabIndex: '0' }),
        Object(preact_min["h"])(Options_Options, { name: 'unrest', title: 'Unrest', items: options_config["UNREST"], disabled: selectedOptions !== 'unrest', onSelect: this.onSelect, onInput: this.onOptionChange, tabIndex: '0' })
      ),
      Object(preact_min["h"])(
        StatsBox_StatsBox,
        { year: year, totalDeaths: totalDeaths, totals: summaryTotals, visible: !!totalDeaths, fadeIn: 620 },
        commentaries && commentaries.length > 0 && _ref8
      ),
      Object(preact_min["h"])(Commentary_Commentary, { items: commentaries })
    );
  };

  return Country;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./assets/data/country-events.json
var country_events = __webpack_require__("Fil1");
var country_events_default = /*#__PURE__*/__webpack_require__.n(country_events);

// CONCATENATED MODULE: ./lib/countries.js
// import { fetch } from './utils';
// import { getCountryEvents } from './countryEvents';

// export const getCountries = getCountryEvents;



var appDataPromise = Promise.resolve(country_events_default.a);

function getCountries() {
  return appDataPromise;
}

// export function getCountries ({ includeEvents = false } = {}) {
//   if (includeEvents) {
//     return Promise.all([countriesPromise, getCountryEvents()])
//       .then(([countries, countryEvents]) => {
//         return Object.keys(countryEvents).reduce((countryData, countryId) => {
//           countryData[countryId] = {
//             ...countries[countryId],
//             ...countryEvents[countryId]
//           };

//           return countryData;
//         }, {});
//       });
//   }

//   return countriesPromise;
// }

// const countriesPromise = fetch('/assets/countries.txt')
// .then(data => {
//   const countries = {};

//   data.trim().split('\n').forEach(line => {
//     const id = line.slice(0,2).toLowerCase();
//     const name = line.slice(3);

//     countries[id] = {
//       name
//     };
//   });

//   return countries;
// });
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_App; });
var index__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import Match from 'preact-router/match';





// import { getIcons } from './lib/icons';


// function currentCountry () {
//   const path = window.location.pathname;

//   return path.slice(-3,-2) === '/' && path.slice(-2) || null;
// }


// Redirect hash URLs
function redirectHashUrl() {
  var hash = window.location.hash;


  if (hash && hash.length > 1) {
    var _parsePath = parsePath(hash.slice(1)),
        countryId = _parsePath.countryId,
        year = _parsePath.year;

    setRoute(year, countryId, true);
    return true;
  }
}

// minimal-ui for iOS 
// let viewportMeta = document.querySelector('head meta[name="viewport"]');

// if (viewportMeta) {
//   let content = viewportMeta.getAttribute('content') || '';

//   content += (content ? ', ' : '') + 'minimal-ui';
//   viewportMeta.setAttribute('content', content);
// }

// else {
//   viewportMeta = document.createElement('meta');
//   viewportMeta.setAttribute('name', 'viewport');
//   viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, minimal-ui');
//   document.querySelector('head').appendChild(viewportMeta);
// }

var index__ref = Object(preact_min["h"])(Header_Header, null);

var index__ref2 = Object(preact_min["h"])(
  'footer',
  null,
  Object(preact_min["h"])(
    'a',
    { 'class': 'org', href: 'https://aru.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/about', target: '_blank' },
    'About'
  ),
  Object(preact_min["h"])(
    'div',
    { 'class': 'download' },
    Object(preact_min["h"])(
      'a',
      { native: true, download: 'aru-chaosmap.csv', href: '/assets/data/aru-chaosmap.csv' },
      'Download data'
    )
  )
);

var index_App = function (_Component) {
  index__inherits(App, _Component);

  function App(props) {
    index__classCallCheck(this, App);

    // getIcons()
    // .then(icons => {
    //   document.body.insertBefore(icons, document.body.firstChild);
    // });

    var _this = index__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = index__extends({
      countries: null,
      minYear: null,
      maxYear: null
    }, currentPath());

    _this.handleRoute = function (event) {
      if (redirectHashUrl()) {
        return;
      }

      var url = event.url;

      var _currentPath = currentPath(),
          countryId = _currentPath.countryId,
          year = _currentPath.year;

      var countries = _this.state.countries;

      // console.log('handleRoute', { countryId, countries: !!countries, url }, this.state.countryId);

      if (countryId && countries && !(countryId in countries)) {
        setRoute(null, null, true);
        return;
      }

      if (_this.state.countryId !== countryId) {
        if (!countryId) {
          if (document.activeElement) {
            document.activeElement.blur();
          }
        }

        // console.log(`set state ${this.state.countryId} -> ${countryId}`);
        _this.setState({ countryId: countryId });
      }

      if (_this.state.year !== year) {
        // console.log(`set state ${this.state.year} -> ${year}`);
        _this.setState({ year: year });
      }
    };

    _this.setYear = function (year) {
      setRoute(year, _this.state.countryId);
    };

    getCountries().then(function (countries) {
      var yearRange = Object.keys(countries).reduce(function (result, countryId) {
        var years = Object.keys(countries[countryId].eventsByYear).sort().map(Number);
        var firstYear = years[0];
        var lastYear = years[years.length - 1];

        if (firstYear < result.minYear) {
          result.minYear = firstYear;
        }

        if (lastYear > result.maxYear) {
          result.maxYear = lastYear;
        }

        return result;
      }, { minYear: Infinity, maxYear: 0 });

      _this.setState(index__extends({ countries: countries }, yearRange));
    });
    return _this;
  }

  App.prototype.render = function render() {
    var _state = this.state,
        countries = _state.countries,
        countryId = _state.countryId,
        year = _state.year,
        minYear = _state.minYear,
        maxYear = _state.maxYear;
    // console.log('index', {countries: !!countries, countryId, year, minYear, maxYear});

    if (!countries) {
      return null;
    }

    var country = countryId && countries[countryId];
    var eventsByYear = country && country.eventsByYear[year];
    var hasCommentaries = eventsByYear && eventsByYear.some(function (event) {
      return !!event.commentary;
    });

    return Object(preact_min["h"])(
      'div',
      { 'class': 'app' },
      Object(preact_min["h"])(MapControls_MapControls, {
        showPan: !countryId,
        showZoom: !countryId,
        showYear: true,
        showIconsLegend: false,
        onChangeYear: this.setYear,
        minYear: minYear,
        maxYear: maxYear,
        year: year
      }),
      Object(preact_min["h"])(
        preact_router_es_Router,
        { onChange: this.handleRoute },
        Object(preact_min["h"])(
          'div',
          { id: 'content', path: '/:countryId?/:year?' },
          index__ref,
          Object(preact_min["h"])(
            'main',
            { 'class': hasCommentaries && 'has-commentaries' },
            Object(preact_min["h"])(WorldMap_WorldMap, { selectedCountry: countryId, countries: countries, year: year || maxYear }),
            Object(preact_min["h"])(Country_Country, { country: country, year: year || maxYear })
          ),
          index__ref2
        )
      )
    );
  };

  return App;
}(preact_min["Component"]);



/***/ }),

/***/ "uXl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("EBst");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "xKUf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.1892b.js